<template>
  <div>
    <v-card class="rounded-xl" color="cardOne" id="card-main" style="background-color: #fafafa !important">
      <v-container :class="$vuetify.breakpoint.name == 'xs' ? '' : 'pr-8 pl-8'" fluid>
        <v-row align="center" id="header" v-show="!(ocultarHeaderMobile && $vuetify.breakpoint.smAndDown)">
          <v-col cols="12" v-if="mostrarAlerta">
            <v-alert style="background-color: rgb(219, 29, 74);color: white;" icon="$success" title="Información">
              Servicio en mantenimiento todo el fin de semana, puede presentarse intermitencias. Sugerimos operar desde
              el Lunes.
            </v-alert>
          </v-col>
          <!-- CETAE: oculto. El aviso promociona la app "IEA Autogestión" (stores de IEA); reactivar cuando cetae tenga app propia. -->
          <v-col v-if="false" cols="12" sm="12" xs="12" md="3" lg="3" xl="3" class="d-md-none">
            <v-alert style="background-color: #856404;color: white;" icon="$success" title="Información"> <a
                style="color:white;text-decoration: none;cursor: pointer;"
                href="https://play.google.com/store/apps/details?id=com.itoeste.iea&pcampaignid=web_share"
                target="_blank">Para una mejor experiencia descarga Nuestra App disponible en Android e <a
                  style="color:white;text-decoration: none;cursor: pointer;"
                  href="https://apps.apple.com/us/app/iea-autogesti%C3%B3n/id1544496086" target="_blank">iOS</a></a>
            </v-alert>
          </v-col>
          <v-col cols="4" sm="4" xs="4" md="2" lg="2" xl="2" style="text-align: center;">
            <v-img class="ml-2" contain :aspect-ratio="5 / 1" width="120" :src="require('../assets/logo-header2.png')"
              @click="$router.push('/home')" style="cursor: pointer;"></v-img>
          </v-col>
          <v-col cols="8" sm="8" xs="8" md="3" lg="3" xl="3" class="d-md-none">
            <div
              class="text-right text-xs-h5 text-sm-h5 text-md-h5 text-lg-h5 text-xl-h5 grey--text font-weight-light mr-5 g-0 d-flex flex-direction-row justify-end align-center"
              v-if="profile && token != '' && user && user.IDStB && user.borrado !== '1' && !user.excedente && user.alumno_mora !== true && user.tipoUsuario == 'alumno'">
              <v-badge color="red" class="" :content="notifications.general.total" overlap
                v-if="notifications.general.total > 0">
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn color="primary" dark v-bind="attrs" v-on="on" class="mx-2" fab x-small
                      @click="LoadNotifications('general')" title="Notificaciones">
                      <v-icon dark>
                        mdi-bell-outline
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-list v-if="notifications.general.items.length > 0">
                    <v-list-item v-for="(notification, index) in notifications.general.items" :key="index"
                      :style="{ 'background-color': notification.read ? 'white' : '#f1f1f1' }"
                      @click="openNotification(notification);">
                      <v-list-item-content>
                        <v-list-item-title>{{ notification.title }}</v-list-item-title>
                        <v-list-item-subtitle :style="{ 'font-weight': notification.read ? 'normal' : 'bold' }">{{
                          notification.message }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-badge>
              <v-menu max-width="17%" class="" left offset-y v-else>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="primary" dark v-bind="attrs" v-on="on" class="mx-2" fab x-small
                    @click="LoadNotifications('general')" title="Notificaciones">
                    <v-icon dark>
                      mdi-bell-outline
                    </v-icon>
                  </v-btn>
                </template>
                <v-list v-if="notifications.general.items.length > 0">
                  <v-list-item v-for="(notification, index) in notifications.general.items" :key="index"
                    :style="{ 'background-color': notification.read ? 'white' : '#f1f1f1' }"
                    @click="openNotification(notification);">
                    <v-list-item-content>
                      <v-list-item-title>{{ notification.title }}</v-list-item-title>
                      <v-list-item-subtitle :style="{ 'font-weight': notification.read ? 'normal' : 'bold' }">{{
                        notification.message }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-btn color="orange" dark class="mx-2 " fab x-small @click="goChats()"
                v-if="$route.name == 'Publicacion' || $route.name == 'Profile'" title="Ver chat">
                <v-icon dark>
                  mdi-message-processing
                </v-icon>
              </v-btn>
              <v-btn color="red" dark class="mx-2 " fab x-small @click="goPublications()" v-else title="Ver posteos">
                <v-icon dark>
                  mdi-newspaper
                </v-icon>
              </v-btn>

            </div>
            <div
              class="text-right text-xs-h5 text-sm-h5 text-md-h5 text-lg-h5 text-xl-h5 grey--text font-weight-light mr-5 g-0 d-flex flex-direction-row justify-end align-center"
              v-if="user.tipoUsuario == 'profesor'">
              <v-badge color="red" class="" :content="notificationsDocente.general.total" overlap
                v-if="notificationsDocente.general.total > 0">
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn color="primary" dark v-bind="attrs" v-on="on" class="mx-2" fab x-small
                      @click="LoadNotificationsDocente('general')" title="Notificaciones">
                      <v-icon dark>
                        mdi-bell-outline
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-list v-if="notificationsDocente.general.items.length > 0">
                    <v-list-item v-for="(notification, index) in notificationsDocente.general.items" :key="index"
                      :style="{ 'background-color': notification.read ? 'white' : '#f1f1f1' }"
                      @click="openNotification(notification);">
                      <v-list-item-content>
                        <v-list-item-title>{{ notification.title }}</v-list-item-title>
                        <v-list-item-subtitle :style="{ 'font-weight': notification.read ? 'normal' : 'bold' }">{{
                          notification.message }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-badge>
              <v-menu max-width="17%" class="" left offset-y v-else>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="primary" dark v-bind="attrs" v-on="on" class="mx-2" fab x-small
                    @click="LoadNotificationsDocente('general')" title="Notificaciones">
                    <v-icon dark>
                      mdi-bell-outline
                    </v-icon>
                  </v-btn>
                </template>
                <v-list v-if="notificationsDocente.general.items.length > 0">
                  <v-list-item v-for="(notification, index) in notificationsDocente.general.items" :key="index"
                    :style="{ 'background-color': notification.read ? 'white' : '#f1f1f1' }"
                    @click="openNotification(notification);">
                    <v-list-item-content>
                      <v-list-item-title>{{ notification.title }}</v-list-item-title>
                      <v-list-item-subtitle :style="{ 'font-weight': notification.read ? 'normal' : 'bold' }">{{
                        notification.message }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                  </v-list-item>
                </v-list>
              </v-menu>



            </div>
          </v-col>
          <v-col cols="8" sm="8" xs="8" md="3" lg="3" xl="3" class="d-none d-sm-none d-md-flex">
            <v-card class="rounded-xl" elevation="0" v-if="profile && token != ''">
              <v-list-item two-line>
                <v-list-item-avatar>
                  <v-menu bottom min-width="200px" rounded offset-y>
                    <template v-slot:activator="{ on }">
                      <v-btn icon v-on="on">


                        <v-avatar :size="user.imagen == null ? '40' : '60'" density="default" title="Ver perfil">

                          <div class="v-image v-responsive theme--light">
                            <div class="v-responsive__sizer" style="padding-bottom: 190.399%;"></div>
                            <div class="v-image__image v-image__image--cover"
                              v-bind:style="{ 'background-image': 'url(' + (imagenbs == null ? require('../assets/user.png') : imagenbs) + ')', 'background-position': 'center center' }">
                            </div>
                            <div class="v-responsive__content" style="width: 1229px;"></div>
                          </div>
                        </v-avatar>

                      </v-btn>
                    </template>
                    <v-card>
                      <v-list-item-content class="justify-center">
                        <div class="mx-auto text-center">
                          <v-avatar :size="user.imagen == null ? '40' : '60'" density="default" title="Ver perfil"
                            style="cursor: pointer;" @click="$router.push('profile/' + user.IDStB);">

                            <div class="v-image v-responsive theme--light">
                              <div class="v-responsive__sizer" style="padding-bottom: 190.399%;"></div>
                              <div class="v-image__image v-image__image--cover"
                                v-bind:style="{ 'background-image': 'url(' + (imagenbs == null ? require('../assets/user.png') : imagenbs) + ')', 'background-position': 'center center' }">
                              </div>
                              <div class="v-responsive__content" style="width: 1229px;"></div>
                            </div>
                          </v-avatar>

                          <h3 @click="$router.push('profile/' + user.IDStB);" style="cursor: pointer;">{{ user.Nombres
                          }}
                            {{
                              user.Apellidos }}</h3>
                          <p class="caption mt-1">
                            {{ user.email }}
                          </p>
                          <v-divider class="my-3"></v-divider>
                          <!-- <v-btn
                        depressed
                        rounded
                        text
                      >
                        Edit Account
                      </v-btn> -->
                          <!-- <v-divider class="my-3"></v-divider> -->
                          <div v-if="user.borrado !== '1' && !user.excedente && user.alumno_mora !== true">
                            <v-btn @click="changePassword()" depressed rounded text
                              class="black--text rounded-lg font-weight-regular">
                              Cambiar contraseña
                            </v-btn>
                            <v-divider class="my-3"></v-divider>
                          </div>
                          <div v-if="user.borrado !== '1' && !user.excedente && user.alumno_mora !== true">
                            <v-btn @click="$router.push('settings');" depressed rounded text
                              class="black--text rounded-lg font-weight-regular">
                              Ajustes
                            </v-btn>
                            <v-divider class="my-3"></v-divider>
                          </div>
                          <v-btn @click="logout()" depressed rounded text
                            class="black--text rounded-lg font-weight-regular">
                            Salir
                          </v-btn>
                        </div>
                      </v-list-item-content>
                    </v-card>
                  </v-menu>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-subtitle>Bienvenid@


                    <div class="row ml-0" v-if="showRating">

                      <star-rating v-model="rating" v-bind:increment="0.01" v-bind:max-rating="5"
                        inactive-color="#f1f1f1" active-color="#FFD700" v-bind:star-size="20" v-bind:read-only="true"
                        v-bind:show-rating="false">

                      </star-rating>

                      <div class="ml-3">
                        <p class="mt-4"> {{ rating.toFixed(1) }}</p>
                      </div>
                    </div>

                  </v-list-item-subtitle>
                  <v-list-item-title style="font-size:.8rem;"><strong>Reputación
                      Institucional</strong></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>

          <v-col v-if="profile && token != ''" cols="12" sm="12" xs="12" md="3" lg="3" xl="3" class="d-md-none">
            <v-card class="rounded-xl" elevation="0" v-if="profile && token != ''">
              <v-list-item two-line>
                <v-list-item-avatar>
                  <v-menu bottom min-width="200px" rounded offset-y>
                    <template v-slot:activator="{ on }">
                      <v-btn icon v-on="on">


                        <v-avatar :size="user.imagen == null ? '40' : '60'" density="default" title="Ver perfil">

                          <div class="v-image v-responsive theme--light">
                            <div class="v-responsive__sizer" style="padding-bottom: 190.399%;"></div>
                            <div class="v-image__image v-image__image--cover"
                              v-bind:style="{ 'background-image': 'url(' + (user.imagen == null ? require('../assets/user.png') : user.imagen) + ')', 'background-position': 'center center' }">
                            </div>
                            <div class="v-responsive__content" style="width: 1229px;"></div>
                          </div>
                        </v-avatar>

                      </v-btn>
                    </template>
                    <v-card>
                      <v-list-item-content class="justify-center">
                        <div class="mx-auto text-center">
                          <v-avatar :size="user.imagen == null ? '40' : '60'" density="default" title="Ver perfil"
                            style="cursor: pointer;" @click="$router.push('profile/' + user.IDStB);">

                            <div class="v-image v-responsive theme--light">
                              <div class="v-responsive__sizer" style="padding-bottom: 190.399%;"></div>
                              <div class="v-image__image v-image__image--cover"
                                v-bind:style="{ 'background-image': 'url(' + (user.imagen == null ? require('../assets/user.png') : user.imagen) + ')', 'background-position': 'center center' }">
                              </div>
                              <div class="v-responsive__content" style="width: 1229px;"></div>
                            </div>
                          </v-avatar>

                          <h3 @click="$router.push('profile/' + user.IDStB);" style="cursor: pointer;">{{ user.Nombres
                          }}
                            {{
                              user.Apellidos }}</h3>
                          <p class="caption mt-1">
                            {{ user.email }}
                          </p>
                          <v-divider class="my-3"></v-divider>
                          <!-- <v-btn
                        depressed
                        rounded
                        text
                      >
                        Edit Account
                      </v-btn> -->
                          <!-- <v-divider class="my-3"></v-divider> -->
                          <div v-if="user.borrado !== '1' && !user.excedente && user.alumno_mora !== true">
                            <v-btn @click="changePassword()" depressed rounded text
                              class="black--text rounded-lg font-weight-regular">
                              Cambiar contraseña
                            </v-btn>
                            <v-divider class="my-3"></v-divider>
                          </div>
                          <div v-if="user.borrado !== '1' && !user.excedente && user.alumno_mora !== true">
                            <v-btn @click="$router.push('settings');" depressed rounded text
                              class="black--text rounded-lg font-weight-regular">
                              Ajustes
                            </v-btn>
                            <v-divider class="my-3"></v-divider>
                          </div>
                          <v-btn @click="logout()" depressed rounded text
                            class="black--text rounded-lg font-weight-regular">
                            Salir
                          </v-btn>
                        </div>
                      </v-list-item-content>
                    </v-card>
                  </v-menu>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-subtitle>Bienvenid@


                    <div class="row ml-0" v-if="showRating">

                      <star-rating v-model="rating" v-bind:increment="0.01" v-bind:max-rating="5"
                        inactive-color="#f1f1f1" active-color="#FFD700" v-bind:star-size="20" v-bind:read-only="true"
                        v-bind:show-rating="false">

                      </star-rating>

                      <div class="ml-3">
                        <p class="mt-4"> {{ rating.toFixed(1) }}</p>
                      </div>
                    </div>

                  </v-list-item-subtitle>
                  <v-list-item-title style="font-size:.8rem;"><strong>Reputación
                      Institucional</strong></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
          <v-col v-if="profile && token != ''" cols="12" sm="12" xs="12" md="2" lg="2" xl="2">
            <v-col v-if="mostrarPosicion">
              <v-card v-if="profile && token != ''" class="rounded-xl flex-direction-row justify-center align-center"
                elevation="0" style="cursor:pointer;" @click="modalRanking()">
                <v-list-item two-line class="flex-direction-row justify-center align-center">
                  <v-list-item-avatar class="flex-direction-row justify-center align-center">
                    <v-menu bottom min-width="200px" rounded offset-y>
                      <template v-slot:activator="{ on }">
                        <v-btn icon v-on="on">
                          <v-avatar :size="user.imagen == null ? '40' : '60'" density="default" title="Ver Ranking">
                            <div class="v-image v-responsive theme--light">
                              <div class="v-responsive__sizer" style="padding-bottom: 190.399%;"></div>
                              <div class="v-image__image v-image__image--cover"
                                v-bind:style="{ 'background-image': 'url(' + (user.imagen == null ? require('../assets/user.png') : user.imagen) + ')', 'background-position': 'center center' }">
                              </div>
                              <div class="v-responsive__content" style="width: 1229px;"></div>
                            </div>
                          </v-avatar>

                        </v-btn>
                      </template>

                    </v-menu>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-subtitle>

                    </v-list-item-subtitle>
                    <v-list-item-title style="font-size:1rem;"><strong>Posición: #
                        {{ posicionRanking }}</strong></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </v-col>
          </v-col>
          <v-col
            v-if="profile && token != '' && user && user.IDStB && user.borrado !== '1' && !user.excedente && user.alumno_mora !== true && user.tipoUsuario == 'alumno'"
            class="d-md-none" cols="12" sm="12" xs="12" md="4" lg="4" xl="4">
            <v-row class=" flex-direction-row justify-center align-center">
              <v-col cols="3" sm="3" xs="3" md="2" lg="2" xl="2" style="text-align: center;">
                <v-img :aspect-ratio="16 / 9" @click="mostrarModalInicial()"
                  title="¡Gracias por ingresar a la plataforma!" style="cursor: pointer;" width="120" contain
                  :src="require('../assets/inicial.png')"></v-img>
              </v-col>
              <v-col cols="3" sm="3" xs="3" md="2" lg="2" xl="2" style="text-align: center;">
                <v-img @click="!tieneBadge1 ? modalBadge(1) : modalBadgeGanado(1)" style="cursor: pointer;"
                  :class="!tieneBadge1 ? 'badge-no' : ''" :aspect-ratio="16 / 9"
                  :title="tieneBadge1 ? 'Premio Perseverancia: ¡3 días seguidos estudiando!' : ''" width="120" contain
                  :src="require('../assets/bronce2.png')"></v-img>
                <v-progress-linear rounded v-if="!tieneBadge1" class="mt-2" v-model="porcentaje1" height="13">
                </v-progress-linear>
              </v-col>
              <v-col v-if="tieneBadge1" cols="3" sm="3" xs="3" md="2" lg="2" xl="2" style="text-align: center;">
                <v-img @click="!tieneBadge2 ? modalBadge(2) : modalBadgeGanado(2)" style="cursor: pointer;"
                  :class="!tieneBadge2 ? 'badge-no' : ''" :aspect-ratio="16 / 9"
                  :title="tieneBadge2 ? 'Premio Perseverancia: ¡5 días seguidos estudiando!' : ''" width="120" contain
                  :src="require('../assets/plata2.png')"></v-img>
                <v-progress-linear rounded v-if="!tieneBadge2" class="mt-2" v-model="porcentaje2" height="13">
                </v-progress-linear>
              </v-col>
              <v-col v-if="tieneBadge2" cols="3" sm="3" xs="3" md="2" lg="2" xl="2" style="text-align: center;">
                <v-img @click="!tieneBadge3 ? modalBadge(3) : modalBadgeGanado(3)" style="cursor: pointer;"
                  :class="!tieneBadge1 ? 'badge-no' : ''" :aspect-ratio="16 / 9"
                  :title="tieneBadge3 ? 'Premio Perseverancia: !10 días seguidos estudiando!' : ''" width="120" contain
                  :src="require('../assets/oro2.png')"></v-img>
                <v-progress-linear rounded v-if="!tieneBadge3" class="mt-2" v-model="porcentaje3" height="13">
                </v-progress-linear>
              </v-col>
            </v-row>
          </v-col>

          <v-col
            v-if="profile && token != '' && user && user.IDStB && user.borrado !== '1' && !user.excedente && user.alumno_mora !== true && user.tipoUsuario == 'alumno'"
            cols="12" sm="12" xs="12" md="5" lg="5" xl="5">
            <div
              class="text-right text-xs-h5 text-sm-h5 text-md-h5 text-lg-h5 text-xl-h5 grey--text font-weight-light mr-5 g-0 d-flex flex-direction-row justify-end align-center"
              v-if="user && user.IDStB && user.borrado !== '1' && !user.excedente && user.alumno_mora !== true && user.tipoUsuario == 'alumno'">
              <v-row class=" flex-direction-row justify-end d-none d-sm-none d-md-flex mr-5 align-center">
                <v-col cols="3" sm="3" xs="3" md="3" lg="3" xl="3" style="text-align: center;margin-left: -5%;">
                  <v-img style="cursor: pointer;" @click="mostrarModalInicial()" :aspect-ratio="16 / 9"
                    title="¡Gracias por ingresar a la plataforma!" width="120" contain
                    :src="require('../assets/inicial.png')"></v-img>
                </v-col>
                <v-col cols="3" sm="3" xs="3" md="3" lg="3" xl="3"
                  :style="tieneBadge1 ? 'text-align: center;margin-left: -5%;' : 'text-align: center;'">
                  <v-img style="cursor: pointer;" @click="!tieneBadge1 ? modalBadge(1) : modalBadgeGanado(1)"
                    :class="!tieneBadge1 ? 'badge-no' : ''" :aspect-ratio="16 / 9"
                    :title="tieneBadge1 ? 'Premio Perseverancia: ¡3 días seguidos estudiando!' : ''" width="120" contain
                    :src="require('../assets/bronce2.png')"></v-img>
                  <v-progress-linear rounded v-if="!tieneBadge1" class="mt-2" v-model="porcentaje1" height="13">
                  </v-progress-linear>
                </v-col>
                <v-col v-if="tieneBadge1" cols="3" sm="3" xs="3" md="3" lg="3" xl="3"
                  :style="tieneBadge2 ? 'text-align: center;margin-left: -5%;' : 'text-align: center;'">
                  <v-img style="cursor: pointer;" @click="!tieneBadge2 ? modalBadge(2) : modalBadgeGanado(2)"
                    :class="!tieneBadge2 ? 'badge-no' : ''" :aspect-ratio="16 / 9"
                    :title="tieneBadge2 ? 'Premio Perseverancia: ¡5 días seguidos estudiando!' : ''" width="120" contain
                    :src="require('../assets/plata2.png')"></v-img>
                  <v-progress-linear rounded v-if="!tieneBadge2" class="mt-2" v-model="porcentaje2" height="13">
                  </v-progress-linear>
                </v-col>
                <v-col v-if="tieneBadge2" cols="3" sm="3" xs="3" md="3" lg="3" xl="3"
                  :style="tieneBadge3 ? 'text-align: center;margin-left: -5%;' : 'text-align: center;'">
                  <v-img style="cursor: pointer;" @click="!tieneBadge3 ? modalBadge(3) : modalBadgeGanado(3)"
                    :class="!tieneBadge1 ? 'badge-no' : ''" :aspect-ratio="16 / 9"
                    :title="tieneBadge3 ? 'Premio Perseverancia: !10 días seguidos estudiando!' : ''" width="120"
                    contain :src="require('../assets/oro2.png')"></v-img>
                  <v-progress-linear rounded v-if="!tieneBadge3" class="mt-2" v-model="porcentaje3" height="13">
                  </v-progress-linear>
                </v-col>
              </v-row>


              <v-badge color="red" class="d-none d-sm-none d-md-flex" :content="notifications.general.total" overlap
                v-if="notifications.general.total > 0">
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn color="primary" dark v-bind="attrs" v-on="on" class="mx-2" fab x-small
                      @click="LoadNotifications('general')" title="Notificaciones">
                      <v-icon dark>
                        mdi-bell-outline
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-list v-if="notifications.general.items.length > 0">
                    <v-list-item v-for="(notification, index) in notifications.general.items" :key="index"
                      :style="{ 'background-color': notification.read ? 'white' : '#f1f1f1' }"
                      @click="openNotification(notification);">
                      <v-list-item-content>
                        <v-list-item-title>{{ notification.title }}</v-list-item-title>
                        <v-list-item-subtitle :style="{ 'font-weight': notification.read ? 'normal' : 'bold' }">{{
                          notification.message }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-badge>
              <v-menu max-width="17%" class="d-none d-sm-none d-md-flex" left offset-y v-else>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="primary" dark v-bind="attrs" v-on="on" class="mx-2" fab x-small
                    @click="LoadNotifications('general')" title="Notificaciones">
                    <v-icon dark>
                      mdi-bell-outline
                    </v-icon>
                  </v-btn>
                </template>
                <v-list v-if="notifications.general.items.length > 0">
                  <v-list-item v-for="(notification, index) in notifications.general.items" :key="index"
                    :style="{ 'background-color': notification.read ? 'white' : '#f1f1f1' }"
                    @click="openNotification(notification);">
                    <v-list-item-content>
                      <v-list-item-title>{{ notification.title }}</v-list-item-title>
                      <v-list-item-subtitle :style="{ 'font-weight': notification.read ? 'normal' : 'bold' }">{{
                        notification.message }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-btn color="orange" dark class="mx-2 d-none d-sm-none d-md-flex" fab x-small @click="goChats()"
                v-if="$route.name == 'Publicacion' || $route.name == 'Profile'" title="Ver chat">
                <v-icon dark>
                  mdi-message-processing
                </v-icon>
              </v-btn>
              <v-btn color="red" dark class="mx-2 d-none d-sm-none d-md-flex" fab x-small @click="goPublications()"
                v-else title="Ver posteos">
                <v-icon dark>
                  mdi-newspaper
                </v-icon>
              </v-btn>


            </div>
            <p class="text-right">

            </p>

          </v-col>
          <v-col
            v-if="profile && token != '' && user && user.tipoUsuario == 'profesor'"
            cols="12" sm="12" xs="12" md="5" lg="5" xl="5">
            <div
              class="text-right text-xs-h5 text-sm-h5 text-md-h5 text-lg-h5 text-xl-h5 grey--text font-weight-light mr-5 g-0 d-flex flex-direction-row justify-end align-center"
              v-if="user  && user.tipoUsuario == 'profesor'">

              <v-badge color="red" class="d-none d-sm-none d-md-flex" :content="notificationsDocente.general.total" overlap
                v-if="notificationsDocente.general.total > 0">
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn color="primary" dark v-bind="attrs" v-on="on" class="mx-2" fab x-small
                      @click="LoadNotificationsDocente('general')" title="Notificaciones">
                      <v-icon dark>
                        mdi-bell-outline
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-list v-if="notificationsDocente.general.items.length > 0">
                    <v-list-item v-for="(notification, index) in notificationsDocente.general.items" :key="index"
                      :style="{ 'background-color': notification.read ? 'white' : '#f1f1f1' }"
                      @click="openNotification(notification);">
                      <v-list-item-content>
                        <v-list-item-title>{{ notification.title }}</v-list-item-title>
                        <v-list-item-subtitle :style="{ 'font-weight': notification.read ? 'normal' : 'bold' }">{{
                          notification.message }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-badge>
              <v-menu max-width="17%" class="d-none d-sm-none d-md-flex" left offset-y v-else>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="primary" dark v-bind="attrs" v-on="on" class="mx-2" fab x-small
                    @click="LoadNotificationsDocente('general')" title="Notificaciones">
                    <v-icon dark>
                      mdi-bell-outline
                    </v-icon>
                  </v-btn>
                </template>
                <v-list v-if="notificationsDocente.general.items.length > 0">
                  <v-list-item v-for="(notification, index) in notificationsDocente.general.items" :key="index"
                    :style="{ 'background-color': notification.read ? 'white' : '#f1f1f1' }"
                    @click="openNotification(notification);">
                    <v-list-item-content>
                      <v-list-item-title>{{ notification.title }}</v-list-item-title>
                      <v-list-item-subtitle :style="{ 'font-weight': notification.read ? 'normal' : 'bold' }">{{
                        notification.message }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
            <p class="text-right">

            </p>

          </v-col>
        </v-row>
        <v-row align="center">

          <slot></slot>
        </v-row>
      </v-container>
    </v-card>
    <p style="text-align: center;">
      <small style="color: #ccc;">V.4.1.0</small>
    </p>
    <v-dialog v-model="showPase" persistent max-width="800" scrollable:="true">
      <v-card>
        <v-card-title class="text-h5">
          Aceptar Pase original/Analítico
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="descargarpase">
            <a :href="url_archivo" target="_blank">Descargar Pase</a>
          </v-btn>
          <v-btn color="primary" v-if="archivo_descargado" text @click="acceptPase">
            Acepto Pase
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showTerms" persistent max-width="800" scrollable:="true">
      <v-card>
        <v-card-title class="text-h5">
          Términos y condiciones
        </v-card-title>
        <v-card-text>
          <p><span style="font-weight: 400;">Reglamento de Alumno de Nivel Superior y Formaci&oacute;n Continua</span>
          </p>
          <ol>
            <li><span style="font-weight: 400;"> Encuadre&nbsp;</span></li>
          </ol>
          <p><span style="font-weight: 400;">1.1. El presente Reglamento se dicta en el marco de la Ley de
              Educaci&oacute;n y, por lo tanto, le son propias todas las disposiciones de car&aacute;cter general que
              regulan la actividad de la Instituci&oacute;n.&nbsp;</span></p>
          <p><span style="font-weight: 400;">1.2. El Instituto tiene como finalidad la formaci&oacute;n
              acad&eacute;mica,
              human&iacute;stica y cient&iacute;fica en las distintas disciplinas/profesiones cuya ense&ntilde;anza se
              imparte en sus diversas carreras.&nbsp;</span></p>
          <p><span style="font-weight: 400;">1.3. El Instituto no acepta discriminaci&oacute;n en raz&oacute;n de raza,
              nacionalidad, origen, religi&oacute;n, discapacidad o edad en cualquiera de sus formas o pr&aacute;cticas.
              Se exaltar&aacute; la responsabilidad social y personal as&iacute; como el desarrollo de una conducta
              &eacute;tica en todos los aspectos de la vida intra y extra universitaria.&nbsp;</span></p>
          <p><span style="font-weight: 400;">1.4. Mediante el cumplimiento de las disposiciones de este Reglamento, se
              propender&aacute; a crear en la Instituci&oacute;n las condiciones acad&eacute;micas, administrativas y de
              convivencia que aseguren la m&aacute;s alta eficiencia en todos los aspectos de su actividad.</span></p>
          <p><span style="font-weight: 400;">1.5. La matriculaci&oacute;n en la instituci&oacute;n implica la
              obligaci&oacute;n del conocimiento del Reglamento por parte del alumno, y la misma matriculaci&oacute;n
              implica la aceptaci&oacute;n total, sin protesto del Reglamento.</span></p>
          <p><span style="font-weight: 400;">1.6. Toda modificaci&oacute;n de este Reglamento ser&aacute; v&aacute;lida
              a
              partir de su publicaci&oacute;n en la web institucional.&nbsp;</span></p>
          <p><span style="font-weight: 400;">1.7 El presente reglamento es de adhesi&oacute;n. Su conocimiento se
              reputar&aacute; conocido por todos los alumnos.</span></p>
          <p>&nbsp;</p>
          <ol start="2">
            <li><span style="font-weight: 400;"> Derechos estudiantiles</span></li>
          </ol>
          <p><span style="font-weight: 400;">2.1.1. Recibir una formaci&oacute;n integral y de nivel acad&eacute;mico,
              que
              les proporcione una formaci&oacute;n acorde con sus aptitudes y los dote del acervo cient&iacute;fico,
              habilidades y destrezas necesarios para el futuro ejercicio de su profesi&oacute;n.</span></p>
          <p><span style="font-weight: 400;">2.1.2. Conocer los objetivos, contenidos program&aacute;ticos y criterios
              de
              evaluaci&oacute;n de cada asignatura explicitados por el profesor.</span></p>
          <p><span style="font-weight: 400;">&nbsp;2.1.3. Ser evaluados por sus desempe&ntilde;os y logros, conforme a
              las
              normas acordadas previamente.</span></p>
          <p><span style="font-weight: 400;">&nbsp;2.1.4. Plantear ante las autoridades los problemas que surjan de su
              actividad como estudiantes y peticionar individualmente.&nbsp;</span></p>
          <p><span style="font-weight: 400;">2.1.5. Realizar reclamos, los cuales ser&aacute;n aceptados
              &uacute;nicamente
              cuando los mismos tengan lenguaje adecuado, no sea soez, vulgar o agresivo; y sean realizados por escrito
              en&nbsp; la plataforma de autogesti&oacute;n&nbsp; de la instituci&oacute;n&nbsp;</span></p>
          <p><br /><br /><br /></p>
          <ol start="3">
            <li><span style="font-weight: 400;"> Alumnos&nbsp;</span></li>
          </ol>
          <p><span style="font-weight: 400;">3.1. Ser&aacute;n alumnos del Instituto aquellas personas que, una vez
              satisfechas las condiciones de ingreso, se matriculen con el objeto de seguir los cursos, carreras o
              especializaciones que se dictan en &eacute;l.&nbsp;</span></p>
          <p><span style="font-weight: 400;">3.2. El Instituto reconocer&aacute; las siguientes categor&iacute;as de
              alumnos:&nbsp;</span></p>
          <p><span style="font-weight: 400;">3.2.1. Regular: Se considerar&aacute; alumno regular para la
              obtenci&oacute;n
              del t&iacute;tulo o certificado a aqu&eacute;l que:&nbsp;</span></p>
          <p><span style="font-weight: 400;">- Est&aacute; inscripto de acuerdo con las normas generales del Instituto y
              las particulares de su carrera. A saber:</span></p>
          <ul>
            <li><span style="font-weight: 400;"> 3 (tres) Fotocopias del DNI&nbsp;</span></li>
            <li><span style="font-weight: 400;"> 3 (tres) Fotos Carnet 4x4</span></li>
            <li><span style="font-weight: 400;"> 3 (tres) Fotocopias de la Partida de Nacimiento&nbsp;</span></li>
            <li><span style="font-weight: 400;"> Apto psicof&iacute;sico</span></li>
            <li><span style="font-weight: 400;"> Fotocopia legalizada y autenticada de t&iacute;tulo secundario en el
                caso
                de las carreras de nivel superior. O en su defecto, certificado de t&iacute;tulo en tr&aacute;mite con
                una
                vigencia de 90 d&iacute;as; que no reemplazar&aacute; a la fotocopia legalizada
                autenticada.&nbsp;</span>
            </li>
          </ul>
          <p><span style="font-weight: 400;">- Cumpla con todos los requisitos de correlatividad, evaluaci&oacute;n,
              asistencia y disciplina previstas en el presente Reglamento y en el Reglamento de Estudios.&nbsp;</span>
          </p>
          <p><span style="font-weight: 400;">- Apruebe como m&iacute;nimo dos actividades acad&eacute;micas (asignatura,
              seminario, taller, investigaci&oacute;n) al a&ntilde;o.&nbsp;</span></p>
          <p><span style="font-weight: 400;">-Haya realizado el pago por matriculaci&oacute;n y no tenga deuda superior
              al
              mes.&nbsp;</span></p>
          <p><span style="font-weight: 400;">3.2.2. Condicional: Se considerar&aacute; alumno condicional a aqu&eacute;l
              que no cumpla algunas de las condiciones previstas para el alumno regular contenidas en el presente
              Reglamento de la Instituci&oacute;n. Todos los alumnos al momento de su inscripci&oacute;n poseen
              transitoriamente el car&aacute;cter condicional hasta tanto realicen la entrega de la
              documentaci&oacute;n.&nbsp;&nbsp;</span></p>
          <p><span style="font-weight: 400;">Se autorizar&aacute; de forma autom&aacute;tica la cursada de los alumnos
              en
              forma condicional durante los 6 meses posteriores a su inscripci&oacute;n&nbsp; en la
              instituci&oacute;n.</span></p>
          <p><span style="font-weight: 400;">Luego de ese plazo se requerir&aacute; autorizaci&oacute;n expresa de la
              Secretar&iacute;a Acad&eacute;mica para poder cursar en condici&oacute;n de condicional la que, de
              cualquier
              forma, no habilitar&aacute; para rendir evaluaciones finales de actividades
              acad&eacute;micas.&nbsp;</span>
          </p>
          <p><span style="font-weight: 400;">3.2.3. Alumno en estado de baja: Se considerar&aacute; alumno en&nbsp;
              estado
              de baja a todo alumno&nbsp; que adeude m&aacute;s de un mes de pagos. Y hayan transcurrido 15 d&iacute;as
              de
              la fecha de vencimiento de su cuota.&nbsp;</span></p>
          <p><span style="font-weight: 400;">Los alumnos en estado de baja podr&aacute;n recuperar
              autom&aacute;ticamente
              su calidad de alumno regular al momento de la realizaci&oacute;n del pago por el monto
              adeudado.&nbsp;</span></p>
          <p><span style="font-weight: 400;">La baja conlleva la inhabilitaci&oacute;n de las cuentas institucionales.
              Y&nbsp; la inhabilitaci&oacute;n&nbsp; de la cuenta de autogesti&oacute;n, hasta tanto se realic&eacute;
              el
              pago de la deuda.&nbsp;&nbsp;</span></p>
          <ol start="4">
            <li><span style="font-weight: 400;"> Ingreso e inscripci&oacute;n</span></li>
          </ol>
          <p><span style="font-weight: 400;">&nbsp;4.1. Ser&aacute; condici&oacute;n para el ingreso a las carreras
              superiores poseer t&iacute;tulo o certificado de nivel secundario completo, legalizado por autoridad
              competente y dem&aacute;s requisitos previstos en el art&iacute;culo 3.2 del Reglamento de
              Estudios.&nbsp;</span></p>
          <p><span style="font-weight: 400;">Los aspirantes extranjeros deber&aacute;n cumplimentar los requerimientos
              establecidos en art&iacute;culo 3.2 del referido reglamento. Para los ingresantes en el Secundario
              Acelerado
              o en los cursos de formaci&oacute;n el presente requisito no tendr&aacute; vigencia.&nbsp;</span></p>
          <p><span style="font-weight: 400;">4.2. En cada carrera se podr&aacute;n establecer requerimientos
              espec&iacute;ficos.</span></p>
          <p><span style="font-weight: 400;">&nbsp;4.3. Calendario Acad&eacute;mico</span></p>
          <p><span style="font-weight: 400;">&nbsp;4.3.1. El ciclo lectivo estar&aacute; dividido en dos
              cuatrimestres.&nbsp;</span></p>
          <p><span style="font-weight: 400;">4.3.2. Cada actividad acad&eacute;mica demandar&aacute; el cursado de uno o
              dos cuatrimestres seg&uacute;n establezca el plan de estudios; la asistencia a clases regulares, la
              aprobaci&oacute;n de dos&nbsp; ex&aacute;menes parciales con opci&oacute;n a uno o dos&nbsp;
              recuperatorios
              y la aprobaci&oacute;n de un examen final.&nbsp;</span></p>
          <p><span style="font-weight: 400;">4.3.3. Se dispondr&aacute; un primer cuatrimestre con un m&iacute;nimo de
              diecis&eacute;is semanas de clases entre los meses de marzo a julio.</span></p>
          <p><span style="font-weight: 400;">&nbsp;4.3.4. Se dispondr&aacute; un segundo cuatrimestre, con un
              m&iacute;nimo de diecis&eacute;is semanas de clases entre los meses de agosto a diciembre.&nbsp;</span>
          </p>
          <p><span style="font-weight: 400;">4.3.5. Para algunas actividades acad&eacute;micas podr&aacute; disponerse
              de
              Cursos de Verano, con una carga horaria equivalente a la de los per&iacute;odos cuatrimestrales del
              Calendario Acad&eacute;mico.&nbsp;</span></p>
          <p><span style="font-weight: 400;">4.3.6. Se establecer&aacute;n tres per&iacute;odos o turnos regulares para
              ex&aacute;menes finales en Nivel Superior: febrero / marzo, julio / agosto y noviembre / diciembre y dos
              per&iacute;odos.&nbsp;</span></p>
          <p>&nbsp;</p>
          <ol start="5">
            <li><span style="font-weight: 400;"> Cursado&nbsp;</span></li>
          </ol>
          <p><span style="font-weight: 400;">5.1. Condiciones para poder cursar</span></p>
          <p><span style="font-weight: 400;">&nbsp;Para poder cursar una actividad acad&eacute;mica el alumno
              deber&aacute; reunir las siguientes condiciones:&nbsp;</span></p>
          <p><span style="font-weight: 400;">5.1.1. Estar matriculado en el a&ntilde;o correspondiente y estar inscripto
              en esa actividad acad&eacute;mica.</span></p>
          <p><span style="font-weight: 400;">&nbsp;5.1.2. Haber aprobado el cursado de la actividad acad&eacute;mica
              correlativa.</span></p>
          <p><span style="font-weight: 400;">&nbsp;5.1.3. Tener vigente el cursado de dicha actividad
              acad&eacute;mica.&nbsp;</span></p>
          <p><span style="font-weight: 400;">5.1.4. En casos excepcionales, la Secretar&iacute;a Acad&eacute;mica
              podr&aacute; autorizar el cursado con car&aacute;cter &ldquo;condicional&rdquo; de una actividad
              acad&eacute;mica al alumno que haya perdido algunas de las condiciones previstas para el alumno regular.
              Tal
              excepci&oacute;n se formular&aacute; por escrito, fundamentada y firmada.&nbsp;</span></p>
          <p><span style="font-weight: 400;">5.1.5 Los alumnos menores de 18 a&ntilde;os no podr&aacute;n abandonar el
              establecimiento hasta la finalizaci&oacute;n del horario correspondiente.</span></p>
          <p><span style="font-weight: 400;">&nbsp;5.1.6 Las comunicaciones institucionales se realizan a trav&eacute;s
              de
              las carteleras virtuales de la instituci&oacute;n, a trav&eacute;s de los correos institucionales, o
              casillas de emails declaradas por los alumnos. Es responsabilidad del alumno realizar un acceso
              peri&oacute;dico a dichos medios.</span></p>
          <p><span style="font-weight: 400;">&nbsp;5.2. Aprobaci&oacute;n de la cursada&nbsp;</span></p>
          <p><span style="font-weight: 400;">Para aprobar el cursado de una actividad acad&eacute;mica el alumno
              deber&aacute;:&nbsp;</span></p>
          <p><span style="font-weight: 400;">5.2.1. Cumplir con la condici&oacute;n de asistencia.&nbsp;</span></p>
          <p><span style="font-weight: 400;">5.2.2. Aprobar las instancias de evaluaci&oacute;n establecidas en el plan
              de
              la actividad acad&eacute;mica (trabajos pr&aacute;cticos, ex&aacute;menes parciales, monograf&iacute;as,
              informes, coloquios, etc).&nbsp;</span></p>
          <p><span style="font-weight: 400;">5.3. Condici&oacute;n de asistencia&nbsp;</span></p>
          <p><span style="font-weight: 400;">5.3.1. Para los cursos o carreras de car&aacute;cter presencial ser&aacute;
              indispensable la asistencia del 75% -como m&iacute;nimo- a las clases de cada actividad acad&eacute;mica
              para aprobar el cursado y quedar habilitado para rendir la evaluaci&oacute;n final.</span></p>
          <p><span style="font-weight: 400;">&nbsp;El alumno podr&aacute; solicitar su estado de asistencia en la
              secretar&iacute;a. En las carreras dependientes del Centro iea de educaci&oacute;n a distancia (CIED) la
              condici&oacute;n de asistencia no es obligatoria.</span></p>
          <p><span style="font-weight: 400;">&nbsp;5.3.2. Se admitir&aacute; al alumno una tardanza a clase de hasta 15
              minutos, pasados los cuales se le computar&aacute; media inasistencia que deber&aacute; constar en el
              registro. Del mismo modo, se computar&aacute; media falta si se retirara de la clase 15 minutos antes de
              su
              finalizaci&oacute;n.</span></p>
          <p><span style="font-weight: 400;">&nbsp;5.3.3. El alumno regular que no cumpla con esa asistencia
              perder&aacute; la condici&oacute;n de tal.&nbsp;</span></p>
          <p><span style="font-weight: 400;">5.4. Requerimientos parciales y evaluaci&oacute;n del cursado&nbsp;</span>
          </p>
          <p><span style="font-weight: 400;">5.4.1. En cada actividad acad&eacute;mica, acorde con lo establecido en el
              plan de estudios y por la Coordinaci&oacute;n de la Carrera, se planificar&aacute;n diversos
              requerimientos
              (trabajos pr&aacute;cticos, monograf&iacute;as, investigaciones, coloquios, seminarios, etc.), y sus
              respectivos sistemas de evaluaci&oacute;n.</span></p>
          <p><span style="font-weight: 400;">&nbsp;5.4.2. Las actividades acad&eacute;micas cuatrimestrales
              tendr&aacute;n
              un m&iacute;nimo de dos evaluaciones parciales, y las anuales, un m&iacute;nimo de tres.&nbsp;</span></p>
          <p><span style="font-weight: 400;">5.4.3. El alumno deber&aacute; cumplir satisfactoriamente con la totalidad
              de
              los requerimientos parciales planificados antes de la finalizaci&oacute;n de cada
              cuatrimestre.&nbsp;</span>
          </p>
          <p><span style="font-weight: 400;">5.4.4. La calificaci&oacute;n aplicable en el caso de estos requerimientos
              ser&aacute; un n&uacute;mero entero entre 1 (uno) y 10 (diez).&nbsp;</span></p>
          <p><span style="font-weight: 400;">5.4.5. La nota m&iacute;nima de aprobaci&oacute;n del cursado ser&aacute; 4
              (cuatro). Materias de promoci&oacute;n y materias con final obligatorio,&nbsp; nota m&iacute;nima 7
              (siete)</span></p>
          <p><span style="font-weight: 400;">5.4.6 Los alumnos podr&aacute;n optar por realizar hasta un 30% de su
              carrera
              en condici&oacute;n de libre. La inscripci&oacute;n a materias libres ser&aacute; en el primer
              cuatrimestre
              desde su comienzo&nbsp; hasta el d&iacute;a 30/4 de cada a&ntilde;o; y&nbsp; en el segundo, desde su
              comienzo hasta el d&iacute;a 30/9 de cada a&ntilde;o</span></p>
          <p><span style="font-weight: 400;">&nbsp;5.5. Recuperaci&oacute;n de requerimientos parciales&nbsp;</span></p>
          <p><span style="font-weight: 400;">5.5.1. El alumno que no hubiera asistido o hubiera reprobado alguno de los
              requerimientos parciales correspondientes al cursado de una actividad acad&eacute;mica, podr&aacute;
              recuperarlo en las fechas establecidas en el calendario acad&eacute;mico. S&oacute;lo se admitir&aacute;
              la
              recuperaci&oacute;n de un parcial en las actividades acad&eacute;micas cuatrimestrales. El alumno
              podr&aacute; asistir a periodo compensatorio como &uacute;ltima instancia para regularizaci&oacute;n de la
              materia.</span></p>
          <p><span style="font-weight: 400;">&nbsp;5.5.2. De no aprobar la recuperaci&oacute;n, el alumno deber&aacute;
              recursar la asignatura.</span></p>
          <p><span style="font-weight: 400;">&nbsp;5.6. Validez del cursado</span></p>
          <p><span style="font-weight: 400;">&nbsp;5.6.1. La aprobaci&oacute;n de los ex&aacute;menes parciales o
              trabajos
              pr&aacute;cticos de las asignaturas cursadas mediante el r&eacute;gimen de regularidad tendr&aacute; una
              validez de TRES (3) cuatrimestres corridos del calendario acad&eacute;mico, excluido el de
              cursado.&nbsp;</span></p>
          <p><span style="font-weight: 400;">5.6.2. Al perder la regularidad, en caso de excederse los plazos previstos
              en
              el punto&nbsp;</span></p>
          <p><span style="font-weight: 400;">5.6.1 del presente Reglamento el alumno deber&aacute; recursar la actividad
              acad&eacute;mica.&nbsp;</span></p>
          <p>&nbsp;</p>
          <ol start="6">
            <li><span style="font-weight: 400;"> Evaluaciones finales&nbsp;</span></li>
          </ol>
          <p><span style="font-weight: 400;">6.1. Condiciones para rendir examen final</span></p>
          <p><span style="font-weight: 400;">&nbsp;6.1.1. El alumno podr&aacute; rendir la evaluaci&oacute;n final de
              una
              actividad acad&eacute;mica cuando:&nbsp;</span></p>
          <p><span style="font-weight: 400;">- Haya aprobado el cursado (parciales aprobados, trabajos entregados&nbsp;
              y
              asistencia cumplida).&nbsp;</span></p>
          <p><span style="font-weight: 400;">- Haya aprobado el examen final de las correlativas precedentes, si las
              hubiere.</span></p>
          <p><span style="font-weight: 400;">&nbsp;-El alumno se haya inscripto a la modalidad &ldquo;libre&rdquo;
              dentro
              del plazo asignado a tal fin en el calendario acad&eacute;mico.&nbsp;</span></p>
          <p><span style="font-weight: 400;">Ning&uacute;n alumno podr&aacute; rendir en esta modalidad un porcentaje
              mayor al 30 % de su carrera.&nbsp;</span></p>
          <p><span style="font-weight: 400;">6.1.2. Para poder rendir examen final, el alumno deber&aacute; presentar su
              credencial o documento de identidad</span></p>
          <p><span style="font-weight: 400;">6.2. Lugares y horarios&nbsp;</span></p>
          <p><span style="font-weight: 400;">6.2.1. Los tribunales examinadores funcionar&aacute;n en los edificios de
              la
              Instituci&oacute;n.</span></p>
          <p><span style="font-weight: 400;">&nbsp;6.2.2. Los ex&aacute;menes se tomar&aacute;n en los horarios que se
              fijar&aacute;n para tal fin. No se examinar&aacute; m&aacute;s all&aacute; de la hora de cierre
              establecida.
              En caso de no haber concluido su tarea, los tribunales examinadores deber&aacute;n pasar a cuarto
              intermedio, hasta una fecha inmediata que el presidente consultar&aacute; con la Direcci&oacute;n y la
              Secretar&iacute;a Acad&eacute;mica. La nueva fecha ser&aacute; comunicada a los alumnos no
              examinados.&nbsp;</span></p>
          <p><span style="font-weight: 400;">6.3. Modalidad del examen final&nbsp;</span></p>
          <p><span style="font-weight: 400;">6.3.1. Los ex&aacute;menes finales podr&aacute;n ser escritos, orales o de
              otra modalidad, seg&uacute;n las caracter&iacute;sticas de cada actividad acad&eacute;mica.&nbsp;</span>
          </p>
          <p><span style="font-weight: 400;">6.3.2. La presentaci&oacute;n a los ex&aacute;menes finales se
              realizar&aacute; con inscripci&oacute;n previa.&nbsp;</span></p>
          <p><span style="font-weight: 400;">6.4. Calificaci&oacute;n y aprobaci&oacute;n&nbsp;</span></p>
          <p><span style="font-weight: 400;">6.4.1. La calificaci&oacute;n que otorga el tribunal al alumno ser&aacute;
              un
              n&uacute;mero entero entre 1 (uno) y 10 (diez).</span></p>
          <p><span style="font-weight: 400;">&nbsp;6.4.2. La nota m&iacute;nima de aprobaci&oacute;n ser&aacute; 4
              (cuatro).&nbsp;</span></p>
          <p><span style="font-weight: 400;">6.4.3. El alumno que no aprobara el examen final puede rendirlo nuevamente
              en
              las fechas establecidas en el Calendario Acad&eacute;mico.</span></p>
          <p><span style="font-weight: 400;">&nbsp;6.4.4. Si el alumno resultara reprobado tres veces consecutivas en
              una
              actividad acad&eacute;mica, debe recursarla.</span></p>
          <p><span style="font-weight: 400;">6.5. De la correlatividad&nbsp;</span></p>
          <p><span style="font-weight: 400;">6.5.1. El alumno que deba recursar una actividad acad&eacute;mica no
              podr&aacute; rendir las correlativas de &eacute;sta, tal como lo determinar&aacute; la articulaci&oacute;n
              vertical de cada plan de estudios.&nbsp;</span></p>
          <p><span style="font-weight: 400;">6.5.2. El alumno que hubiera aprobado la cursada de una actividad
              acad&eacute;mica y tuviera pendiente el examen final, podr&aacute; cursar las correlativas de &eacute;sta
              y
              cumplir los requerimientos parciales, pero no podr&aacute; rendir la evaluaci&oacute;n final hasta tanto
              no
              haya aprobado el examen final de la correlativa anterior.&nbsp;</span></p>
          <p>&nbsp;</p>
          <ol start="7">
            <li><span style="font-weight: 400;"> R&eacute;gimen de equivalencias&nbsp;</span></li>
          </ol>
          <p><span style="font-weight: 400;">7.1. El Instituto reconocer&aacute; las actividades acad&eacute;micas
              aprobadas en otras instituciones de nivel superior que poseen reconocimiento oficial.&nbsp;</span></p>
          <p><span style="font-weight: 400;">7.2. Para lograr el otorgamiento de equivalencias el alumno deber&aacute;
              presentar:&nbsp;</span></p>
          <p><span style="font-weight: 400;">- Solicitud de equivalencias dentro del Sistema de Gesti&oacute;n Integral
              y
              remitir los comprobantes&nbsp; a la Secretar&iacute;a Acad&eacute;mica seg&uacute;n el siguiente
              punto:&nbsp;</span></p>
          <p><span style="font-weight: 400;">- Constancia o t&iacute;tulo anal&iacute;tico de aprobaci&oacute;n de la
              actividad acad&eacute;mica, expedido por autoridad competente de la instituci&oacute;n que la
              aprob&oacute;
              y legalizado.&nbsp;</span></p>
          <p><span style="font-weight: 400;">- Programas foliados y certificados de las actividades acad&eacute;micas
              vigentes al momento de haber sido aprobadas.&nbsp;</span></p>
          <p><span style="font-weight: 400;">7.3. La documentaci&oacute;n presentada ser&aacute; evaluada por los
              docentes
              de las diferentes actividades acad&eacute;micas quienes otorgar&aacute;n las equivalencias que
              ser&aacute;n
              convalidadas por la Secretar&iacute;a Acad&eacute;mica.</span></p>
          <p><span style="font-weight: 400;">&nbsp;7.4. El Instituto tendr&aacute; la potestad de otorgar o no una
              equivalencia.&nbsp;</span></p>
          <p><span style="font-weight: 400;">7.5. Este procedimiento de otorgamiento de equivalencias ser&aacute;
              aplicable tambi&eacute;n a las actividades acad&eacute;micas aprobadas en una carrera del Instituto,
              cuando
              se cursa otra.&nbsp;</span></p>
          <p>&nbsp;</p>
          <ol start="8">
            <li><span style="font-weight: 400;"> Diplomas</span></li>
          </ol>
          <p><span style="font-weight: 400;">&nbsp;8.1. El Instituto otorgar&aacute; el diploma de egresado al alumno
              regular que haya aprobado todas las actividades acad&eacute;micas, as&iacute; como el trabajo final o
              tesina
              y las pr&aacute;cticas profesionales, conforme las previsiones contenidas en el Reglamento de Estudios del
              Instituto.&nbsp;</span></p>
          <p><span style="font-weight: 400;">8.2. Asimismo extender&aacute; un certificado anal&iacute;tico de estudios
              en
              el que constar&aacute;n las actividades acad&eacute;micas aprobadas por el alumno, con indicaci&oacute;n
              de
              las notas obtenidas.&nbsp;</span></p>
          <p>&nbsp;</p>
          <ol start="9">
            <li><span style="font-weight: 400;"> R&eacute;gimen de convivencia&nbsp;</span></li>
          </ol>
          <p><span style="font-weight: 400;">9.1. El Instituto promover&aacute; el desarrollo de la tarea
              acad&eacute;mica
              en un marco de respeto mutuo entre los integrantes de su comunidad. En los casos en que los alumnos
              cometan
              actos que afecten la convivencia y/o el prestigio del Instituto se prev&eacute;n sanciones que se
              aplicar&aacute;n guardando proporci&oacute;n con el tipo y la gravedad de la falta cometida.&nbsp;</span>
          </p>
          <p><span style="font-weight: 400;">9.2. Las sanciones previstas ser&aacute;n las siguientes:&nbsp;</span></p>
          <p><span style="font-weight: 400;">9.2.1. Apercibimiento.&nbsp;</span></p>
          <p><span style="font-weight: 400;">9.2.2. Amonestaci&oacute;n.&nbsp;</span></p>
          <p><span style="font-weight: 400;">9.2.3. Suspensi&oacute;n hasta un (1) a&ntilde;o.</span></p>
          <p><span style="font-weight: 400;">&nbsp;9.2.4. Expulsi&oacute;n.</span></p>
          <p><span style="font-weight: 400;">&nbsp;9.3. Ser&aacute;n causas de:&nbsp;</span></p>
          <p><span style="font-weight: 400;">9.3.1. Apercibimiento: Desobediencia ante &oacute;rdenes razonables y
              ajustadas a reglamento de autoridades, des&oacute;rdenes, faltas de respeto, inconductas, actitudes o
              expresiones contrarias al decoro, todos en grado leve.</span></p>
          <p><span style="font-weight: 400;">&nbsp;9.3.2. Amonestaci&oacute;n: Las mismas causas indicadas para el
              apercibimiento, en grado grave o en reincidencia.&nbsp;</span></p>
          <p><span style="font-weight: 400;">9.3.3. Suspensi&oacute;n: Injurias verbales a autoridades, da&ntilde;os a
              bienes de la Instituci&oacute;n, participaci&oacute;n en tumultos o desmanes dentro del Instituto,
              agresi&oacute;n f&iacute;sica a alumnos, reiteraci&oacute;n de hechos y actos que hubiesen dado lugar al
              apercibimiento o a la amonestaci&oacute;n.&nbsp;</span></p>
          <p><span style="font-weight: 400;">9.3.4. Expulsi&oacute;n: Promoci&oacute;n o realizaci&oacute;n de tumultos
              o
              desmanes, ocupaci&oacute;n de los locales institucionales, agresi&oacute;n f&iacute;sica a autoridades o
              profesores, adulteraci&oacute;n o falsificaci&oacute;n de documentos, reiteraci&oacute;n de actos que
              hubiesen originado la suspensi&oacute;n, ocultamiento de las situaciones indicadas en los apartados 9.7. y
              9.8. 9.4. La precedente enmarcaci&oacute;n no tendr&aacute; car&aacute;cter taxativo.&nbsp;</span></p>
          <p><span style="font-weight: 400;">9.5. La sanci&oacute;n de suspensi&oacute;n importar&aacute; siempre la
              prohibici&oacute;n de acceso a todas las dependencias del Instituto, inclusive en la suspensi&oacute;n
              preventiva que podr&aacute; disponer el Rector/a o Director/a. En este &uacute;ltimo caso, se
              permitir&aacute; el ingreso del alumno cuando sea requerida su presencia a efectos de la
              instrucci&oacute;n
              de la causa correspondiente. El incumplimiento de esta prohibici&oacute;n ser&aacute; sancionado con
              expulsi&oacute;n.&nbsp;</span></p>
          <p><span style="font-weight: 400;">9.6. El alumno becado sancionado perder&aacute; la beca y/o
              descuento.</span>
          </p>
          <p><span style="font-weight: 400;">9.7 Todo proceso disciplinario se realizar&aacute; por expediente
              p&uacute;blico y permanente que ser&aacute; publicado en la web institucional con los datos
              identificativos
              p&uacute;blicos contemplados la ley Ley 25.326 art&iacute;culo 5, inc. c. Con un sumario de los hechos y
              un
              informe pedag&oacute;gico. Sirviendo la aceptaci&oacute;n de este reglamento como consentimiento
              informado.&nbsp;</span></p>
          <p><br /><br /></p>
          <ol start="10">
            <li><span style="font-weight: 400;"> Pagos&nbsp;</span></li>
          </ol>
          <p><span style="font-weight: 400;">10.1 Se llama &ldquo;Arancel&rdquo; al pago mensual que deber&aacute;
              realizar el alumno para mantener su condici&oacute;n regular.&nbsp;</span></p>
          <p><span style="font-weight: 400;">10.2 Se llama &ldquo;Matr&iacute;cula&rdquo; al pago &uacute;nico que se
              realiza al momento de la inscripci&oacute;n. En el caso que el alumno est&eacute; de baja en la
              instituci&oacute;n pasado un a&ntilde;o lectivo, deber&aacute;&nbsp; volver a abonar la matr&iacute;cula
              para poder ser alumno regular de la misma.&nbsp;</span></p>
          <p><span style="font-weight: 400;">10.3 Los aranceles se abonan de forma peri&oacute;dica del d&iacute;a 1 al
              10
              de cada mes correlativamente y hasta finalizar su carrera. Estableci&eacute;ndose un valor con descuento
              del
              10% (diez por ciento) por el pago temprano en las cajas de la instituci&oacute;n. El pago fuera de la
              fecha
              correspondiente implica la p&eacute;rdida de dicho beneficio.&nbsp;</span></p>
          <p><span style="font-weight: 400;">10.4 El Instituto se reserva el derecho de modificar los importes, tanto de
              matr&iacute;cula como de cuotas.&nbsp;</span></p>
          <p><span style="font-weight: 400;">10.5 El alumno que debiera el pago de 1 (un) mes ser&aacute; dado de baja
              en
              el Sistema de Gesti&oacute;n Integral.</span></p>
          <p><span style="font-weight: 400;">10.6 Para poder realizar la inscripci&oacute;n a ex&aacute;menes, materias
              o
              pedidos de documentaci&oacute;n el alumno no deber&aacute; presentar deuda.&nbsp; En el caso de baja de
              estudios, el alumno deber&aacute; tener el estado administrativo al d&iacute;a.</span></p>
          <p><span style="font-weight: 400;">10.7 Algunos tr&aacute;mites a realizarse dentro de la instituci&oacute;n
              poseen costo.&nbsp;</span></p>
          <p><span style="font-weight: 400;">10.8 La regularidad del alumno permite al mismo cursar la cantidad
              correspondiente de materias al cuatrimestre en curso. Seg&uacute;n se encuentre establecido en los
              distintos
              planes de estudio.&nbsp;</span></p>
          <p><span style="font-weight: 400;">10.9 Los aranceles son correlativos en dos ciclos de pago: Febrero a Julio
              y
              de Agosto a Enero. Los alumnos no podr&aacute;n adelantar el pago de cuotas teniendo impagas las cuotas
              anteriores.&nbsp;</span></p>
          <p><span style="font-weight: 400;">10.10 En el caso que el alumno haya aplicado a alg&uacute;n programa de
              beca
              o descuento, siempre que el mismo requiera la suscripci&oacute;n a un sistema de d&eacute;bito
              autom&aacute;tico del arancel, deber&aacute; asegurarse de contar con los fondos suficientes llegado el
              d&iacute;a del d&eacute;bito de cada cuota informado. Si el alumno que habiendo aceptado el descuento y/o
              beca no realiza la suscripci&oacute;n al d&eacute;bito autom&aacute;tico, o no dispone de fondos
              suficientes
              durante los siguientes 30 d&iacute;as, perder&aacute; autom&aacute;ticamente el descuento y/o beca de
              forma
              permanente; y se proceder&aacute; a efectuar la baja de la instituci&oacute;n.&nbsp;</span></p>
          <p><span style="font-weight: 400;">10.11 Ning&uacute;n importe ser&aacute; reembolsado por motivo alguno, a
              excepci&oacute;n que el curso no comience.&nbsp;</span></p>
          <p><span style="font-weight: 400;">10.12 El alumno que al d&iacute;a del examen no tenga las cuotas al
              d&iacute;a no figurar&aacute; en el acta, y por lo tanto no podr&aacute; rendir el mismo.&nbsp;</span></p>
          <p><span style="font-weight: 400;">10.13 Los aranceles se facturan todos los d&iacute;as 1ero de cada mes,
              siempre y cuando los alumnos sean alumnos activos de la instituci&oacute;n. El no pago del arancel es
              pasible, y ser&aacute; reclamado por v&iacute;as legales, reserv&aacute;ndose el derecho la
              instituci&oacute;n de informar el estado de morosidad a las entidades u organismos
              correspondientes.&nbsp;</span></p>
          <p><br /><br /></p>
          <ol start="11">
            <li><span style="font-weight: 400;"> Pr&aacute;cticas Profesionalizantes</span></li>
          </ol>
          <p><span style="font-weight: 400;">11.1 Todas las carreras de nivel superior deber&aacute;n realizar
              Pr&aacute;cticas Profesionalizantes seg&uacute;n establece la Ley de Educaci&oacute;n Superior y las
              distintas reglamentaciones jurisdiccionales pertinentes.</span></p>
          <p><span style="font-weight: 400;">&nbsp;11.2 Las Pr&aacute;cticas son obligatorias y condicionantes para el
              otorgamiento del t&iacute;tulo. Cada a&ntilde;o de carrera posee su correspondiente nivel de
              Pr&aacute;ctica.&nbsp;</span></p>
          <p><span style="font-weight: 400;">11.3 Cada nivel de Pr&aacute;ctica debe cursarse y aprobarse. El
              cumplimiento
              de las actividades de pr&aacute;ctica formativa es obligatorio para la inscripci&oacute;n en las
              pr&aacute;cticas profesionales.</span></p>
          <p><span style="font-weight: 400;">11.4 Las pr&aacute;cticas se reputan autogestionables. Esto quiere decir
              que
              la instituci&oacute;n NO se responsabiliza por el incumplimiento del alumno en el cursado, la
              inscripci&oacute;n o la acreditaci&oacute;n de instancias finales de evaluaci&oacute;n.&nbsp;</span></p>
          <p><span style="font-weight: 400;">&nbsp;11.5 La experiencia laboral no podr&aacute; reputarse como
              Pr&aacute;ctica Profesionalizante.&nbsp;</span></p>
          <p><span style="font-weight: 400;">11.6 El alumno que tenga aprobado todo el plan de estudio a
              excepci&oacute;n
              de las Pr&aacute;cticas Profesionalizantes para poder realizarlas deber&aacute; poseer la condici&oacute;n
              de regularidad, es decir que deber&aacute; realizar el pago de su arancel mensual. Esta condici&oacute;n
              se
              aplica s&oacute;lo si el alumno NO curs&oacute; las pr&aacute;cticas. En el caso que solamente adeude la
              instancia de acreditaci&oacute;n final (examen), no debe seguir abonando el arancel mensual.&nbsp;</span>
          </p>
          <p>&nbsp;</p>
          <ol start="12">
            <li><span style="font-weight: 400;"> Uso de la plataforma de gesti&oacute;n</span></li>
          </ol>
          <p><span style="font-weight: 400;">12.1 Los alumnos deben mantener el decoro en las publicaciones e
              interacciones dentro de la plataforma de gesti&oacute;n.</span></p>
          <p><span style="font-weight: 400;">12.2 No son aceptadas publicaciones con fines comerciales, de militancia
              pol&iacute;tica, ni propaganda sobre organizaciones no gubernamentales, as&iacute; como tampoco es
              aceptada
              ninguna publicaci&oacute;n de activismos, ya sean de &iacute;ndole pol&iacute;tico, de g&eacute;nero, de
              cuestiones ambientales, sociales u otros.&nbsp;</span></p>
          <p><span style="font-weight: 400;">12.3 Est&aacute; prohibido realizar actividades que impliquen interacciones
              no deseadas por otros alumnos tales como: bullying, grooming, acoso deliberado hacia otros alumnos,
              personal
              administrativo o docente de la instituci&oacute;n.&nbsp;</span></p>
          <p><span style="font-weight: 400;">12.4 Se encuentra prohibida la difusi&oacute;n de datos personales, estados
              de pago, consulta sobre pagos, datos de tarjetas de cr&eacute;dito en ning&uacute;n canal p&uacute;blico
              de
              la aplicaci&oacute;n institucional.&nbsp;</span></p>
          <p><span style="font-weight: 400;">12.5 Est&aacute; prohibida la publicaci&oacute;n de posteos que tengan como
              fin el deterioro de la confianza institucional y el menoscabo de la comunidad educativa.</span></p>
          <p><span style="font-weight: 400;">12.6 La instituci&oacute;n se reserva el derecho de moderar, incluyendo
              eliminar, las publicaciones que considere pertinentes.&nbsp;</span></p>
          <p><span style="font-weight: 400;">12.7 Los plazos de inscripci&oacute;n, tanto a cursado de materias, como a
              rendir ex&aacute;menes, no son prorrogables bajo ninguna circunstancia.&nbsp;</span></p>
          <p><span style="font-weight: 400;">12.8 El alumno se considera responsable de tener una conexi&oacute;n
              estable
              de internet a fines de presentarse a las instancias evaluativas correspondientes. No se admite
              ning&uacute;n
              tipo de excepci&oacute;n por problemas de conexi&oacute;n o de suministro el&eacute;ctrico.&nbsp;</span>
          </p>
          <p><span style="font-weight: 400;">12.9 Toda la actividad, incluyendo los datos generados dentro de la
              plataforma, se considera propiedad de la instituci&oacute;n. Reserv&aacute;ndose la instituci&oacute;n el
              derecho a la publicaci&oacute;n o uso de los mismos.&nbsp;</span></p>
          <p>&nbsp;</p>
          <ol start="13">
            <li><span style="font-weight: 400;"> Equivalencias.&nbsp;</span></li>
          </ol>
          <p><span style="font-weight: 400;">13.1 Aquellos alumnos que presenten equivalencias podr&aacute;n cursar y
              rendir con car&aacute;cter condicional las materias correlativas de su plan de estudio.&nbsp;</span></p>
          <p><span style="font-weight: 400;">13.2 el alumno deber&aacute; presentar la documentaci&oacute;n
              respaldatoria
              a su pedido de equivalencias, seg&uacute;n corresponda: Pase, fotocopia sellada y firmada con copia fiel
              del
              libro matriz, o programas sellados y foliados con su correspondiente anal&iacute;tico. De forma
              provisional
              el alumno podr&aacute; firmar una declaraci&oacute;n jurada de materias.&nbsp;</span></p>
          <p><span style="font-weight: 400;">13.3 Si el alumno falsease la declaraci&oacute;n jurada de materias
              deber&aacute; proceder al cursado de las mismas extendi&eacute;ndose en el acto el plazo para la
              finalizaci&oacute;n de sus estudios.&nbsp;</span></p>
          <p>&nbsp;</p>
          <p><span style="font-weight: 400;">Reglamento de Alumnos BCE Secundario Acelerado</span></p>
          <p>&nbsp;</p>
          <ol>
            <li><span style="font-weight: 400;"> Encuadre&nbsp;</span></li>
          </ol>
          <p><span style="font-weight: 400;">1.1. El presente Reglamento se dicta en el marco de la Ley de
              Educaci&oacute;n y, por lo tanto, le son propias todas las disposiciones de car&aacute;cter general que
              regulan la actividad de la Instituci&oacute;n.&nbsp;</span></p>
          <p><span style="font-weight: 400;">1.2. El Instituto tiene como finalidad la formaci&oacute;n
              acad&eacute;mica,
              human&iacute;stica y cient&iacute;fica en las distintas disciplinas/profesiones cuya ense&ntilde;anza se
              imparte en sus diversas carreras.&nbsp;</span></p>
          <p><span style="font-weight: 400;">1.3. El Instituto no acepta discriminaci&oacute;n en raz&oacute;n de raza,
              nacionalidad, origen, religi&oacute;n, discapacidad o edad en cualquiera de sus formas o pr&aacute;cticas.
              Se exaltar&aacute; la responsabilidad social y personal as&iacute; como el desarrollo de una conducta
              &eacute;tica en todos los aspectos de la vida intra y extra institucional.&nbsp;</span></p>
          <p><span style="font-weight: 400;">1.4. Mediante el cumplimiento de las disposiciones de este Reglamento, se
              propender&aacute; a crear en la Instituci&oacute;n las condiciones acad&eacute;micas, administrativas y de
              convivencia que aseguren la m&aacute;s alta eficiencia en todos los aspectos de su actividad.</span></p>
          <p><span style="font-weight: 400;">1.5. La matriculaci&oacute;n en la instituci&oacute;n implica la
              obligaci&oacute;n del conocimiento del Reglamento por parte del alumno, y la misma matriculaci&oacute;n
              implica la aceptaci&oacute;n total, sin protesto del Reglamento.</span></p>
          <p><span style="font-weight: 400;">1.6. Toda modificaci&oacute;n de este Reglamento ser&aacute; v&aacute;lida
              a
              partir de su publicaci&oacute;n en la web institucional.&nbsp;</span></p>
          <p><span style="font-weight: 400;">1.7 El presente reglamento es de adhesi&oacute;n. Su conocimiento se
              reputar&aacute; conocido por todos los alumno.</span></p>
          <p>&nbsp;</p>
          <ol start="2">
            <li><span style="font-weight: 400;"> Derechos estudiantiles</span></li>
          </ol>
          <p><span style="font-weight: 400;">2.1.1. Recibir una formaci&oacute;n integral y de nivel acad&eacute;mico,
              que
              les proporcione una formaci&oacute;n acorde con sus aptitudes y los dote del acervo cient&iacute;fico,
              habilidades y destrezas necesarios para el futuro ejercicio de su profesi&oacute;n.</span></p>
          <p><span style="font-weight: 400;">2.1.2. Ser respetados en sus opiniones y necesidades, as&iacute; como
              recibir
              una atenci&oacute;n para lograr un desempe&ntilde;o satisfactorio en su vida estudiantil.&nbsp;</span></p>
          <p><span style="font-weight: 400;">2.1.3. Conocer los objetivos, contenidos program&aacute;ticos y criterios
              de
              evaluaci&oacute;n de cada asignatura explicitados por el profesor.</span></p>
          <p><span style="font-weight: 400;">&nbsp;2.1.4. Ser evaluados por sus desempe&ntilde;os y logros, conforme a
              las
              normas acordadas previamente.</span></p>
          <p><span style="font-weight: 400;">&nbsp;2.1.5. Plantear ante las autoridades los problemas que surjan de su
              actividad como estudiantes y peticionar individualmente.&nbsp;</span></p>
          <p><span style="font-weight: 400;">2.1.6. Realizar reclamos, los cuales ser&aacute;n aceptados
              &uacute;nicamente
              cuando los mismos tengan lenguaje adecuado, no sea soez, vulgar o agresivo; y sean realizados por escrito
              en&nbsp; la plataforma de autogesti&oacute;n&nbsp; de la instituci&oacute;n.</span></p>
          <p>&nbsp;</p>
          <ol start="3">
            <li><span style="font-weight: 400;"> Alumnos&nbsp;</span></li>
          </ol>
          <p><span style="font-weight: 400;">3.1. Ser&aacute;n alumnos del Instituto aquellas personas que, una vez
              satisfechas las condiciones de ingreso, se matriculen con el objeto de seguir los cursos, carreras o
              especializaciones que se dictan en &eacute;l.&nbsp;</span></p>
          <p><span style="font-weight: 400;">3.2. El Instituto reconocer&aacute; las siguientes categor&iacute;as de
              alumnos:&nbsp;</span></p>
          <p><span style="font-weight: 400;">3.2.1. Regular: Se considerar&aacute; alumno regular para la
              obtenci&oacute;n
              del t&iacute;tulo o certificado a aqu&eacute;l que:&nbsp;</span></p>
          <p><span style="font-weight: 400;">- Est&aacute; inscripto de acuerdo con las normas generales del Instituto y
              las particulares de su carrera. A saber:</span></p>
          <ul>
            <li><span style="font-weight: 400;"> 3 (tres) Fotocopias del DNI&nbsp;</span></li>
            <li><span style="font-weight: 400;"> 3 (tres) Fotos Carnet 4x4</span></li>
            <li><span style="font-weight: 400;"> 3 (tres) Fotocopias de la Partida de Nacimiento</span></li>
          </ul>
          <ul>
            <li style="font-weight: 400;" aria-level="1"><span style="font-weight: 400;">Constancia de pase en
                tr&aacute;mite o anal&iacute;tico parcial del anterior establecimiento educativo. En caso de no haber
                cursado el secundario, certificado de primaria finalizada y aprobada.</span></li>
          </ul>
          <p><span style="font-weight: 400;">- Cumpla con todos los requisitos de correlatividad, evaluaci&oacute;n,
              asistencia y disciplina previstas en el presente Reglamento y en el Reglamento de Estudios.&nbsp;</span>
          </p>
          <p><span style="font-weight: 400;">-Haya realizado el pago por matriculaci&oacute;n y no tenga deuda superior
              a
              los 2 meses.&nbsp;</span></p>
          <p><span style="font-weight: 400;">3.2.2. Condicional: Se considerar&aacute; alumno condicional a aqu&eacute;l
              que no cumpla algunas de las condiciones previstas para el alumno regular contenidas en el presente
              Reglamento de la Instituci&oacute;n. Todos los alumnos al momento de su inscripci&oacute;n poseen
              transitoriamente el car&aacute;cter condicional hasta tanto realicen la entrega de la
              documentaci&oacute;n.&nbsp;&nbsp;</span></p>
          <p><span style="font-weight: 400;">Se autorizar&aacute; de forma autom&aacute;tica la cursada de los alumnos
              en
              forma condicional durante los 6 meses posteriores a su inscripci&oacute;n&nbsp; en la
              instituci&oacute;n.</span></p>
          <p><span style="font-weight: 400;">Luego de ese plazo se requerir&aacute; autorizaci&oacute;n expresa de la
              Secretar&iacute;a Acad&eacute;mica para poder cursar en condici&oacute;n de condicional la que, de
              cualquier
              forma, no habilitar&aacute; para rendir evaluaciones finales de actividades
              acad&eacute;micas.&nbsp;</span>
          </p>
          <p><span style="font-weight: 400;">3.2.3. Alumno en estado de Baja: Se considerar&aacute; alumno en&nbsp;
              estado
              de baja a todo alumno&nbsp; que adeude m&aacute;s de un mes de pagos. Y hayan transcurrido 15 d&iacute;as
              de
              la fecha de vencimiento de su cuota.&nbsp;</span></p>
          <p><span style="font-weight: 400;">Los alumnos en estado de baja podr&aacute;n recuperar
              autom&aacute;ticamente
              su calidad de alumno regular al momento de la realizaci&oacute;n del pago por el monto
              adeudado.&nbsp;</span></p>
          <p><span style="font-weight: 400;">La baja conlleva la inhabilitaci&oacute;n de las cuentas institucionales.
              Y&nbsp; la inhabilitaci&oacute;n&nbsp; de la cuenta de Gesti&oacute;n, hasta tanto se realic&eacute; el
              pago
              de la deuda.&nbsp;&nbsp;</span></p>
          <p>&nbsp;</p>
          <ol start="4">
            <li><span style="font-weight: 400;"> Cursado&nbsp;</span></li>
          </ol>
          <p><span style="font-weight: 400;">4.1. Condiciones para poder cursar</span></p>
          <p><span style="font-weight: 400;">&nbsp;Para poder cursar una actividad acad&eacute;mica el alumno
              deber&aacute; reunir las siguientes condiciones:&nbsp;</span></p>
          <p><span style="font-weight: 400;">4.1.1. Estar matriculado en el a&ntilde;o correspondiente y estar inscripto
              en esa actividad acad&eacute;mica.</span></p>
          <p><span style="font-weight: 400;">&nbsp;4.1.2. Tener vigente el cursado de dicha actividad
              acad&eacute;mica.&nbsp;</span></p>
          <p><span style="font-weight: 400;">4.1.3 Los alumnos menores de 18 a&ntilde;os no podr&aacute;n abandonar el
              establecimiento hasta la finalizaci&oacute;n del horario correspondiente.</span></p>
          <p><span style="font-weight: 400;">&nbsp;4.1.4 Las comunicaciones institucionales se realizan a trav&eacute;s
              de
              las carteleras virtuales de la instituci&oacute;n, a trav&eacute;s de los correos institucionales, o las
              casillas de correo declaradas por los alumnos al momento de la inscripci&oacute;n. Es responsabilidad del
              alumno realizar un acceso peri&oacute;dico a dichos medios.</span></p>
          <p>&nbsp;</p>
          <p><span style="font-weight: 400;">5.1. Condici&oacute;n de asistencia&nbsp;</span></p>
          <p><span style="font-weight: 400;">5.1. La condici&oacute;n de asistencia no es obligatoria. Sin embargo se
              tomar&aacute; lista.</span></p>
          <p>&nbsp;</p>
          <ol start="6">
            <li><span style="font-weight: 400;"> Evaluaciones&nbsp;</span></li>
          </ol>
          <p><span style="font-weight: 400;">6.1. Condiciones para rendir examen final</span></p>
          <p><span style="font-weight: 400;">&nbsp;6.1.1. El alumno deber&aacute; haberse anotado previamente
              seg&uacute;n
              el mecanismo que se encuentre en vigencia.</span></p>
          <p><span style="font-weight: 400;">6.1.2. Para poder rendir examen final, el alumno deber&aacute; presentar su
              credencial o documento de identidad</span></p>
          <p><span style="font-weight: 400;">6.1.3 Deber&aacute; obtener una nota igual&nbsp; o superior a 4&nbsp;
              (cuatro) para aprobar la asignatura.</span></p>
          <p><span style="font-weight: 400;">&nbsp;6.2. De la correlatividad&nbsp;</span></p>
          <p><span style="font-weight: 400;">6.2.1. El alumno que deba una actividad acad&eacute;mica no podr&aacute;
              rendir&nbsp; la/s correlativa/s de &eacute;sta, tal como lo determinar&aacute; la articulaci&oacute;n
              vertical de cada plan de estudios.&nbsp;</span></p>
          <p>&nbsp;</p>
          <ol start="7">
            <li><span style="font-weight: 400;"> R&eacute;gimen de equivalencias&nbsp;</span></li>
          </ol>
          <p><span style="font-weight: 400;">7.1. El Instituto reconocer&aacute; las actividades acad&eacute;micas
              aprobadas en otras instituciones que poseen reconocimiento oficial.&nbsp;</span></p>
          <p><span style="font-weight: 400;">7.2. Para lograr el otorgamiento de equivalencias el alumno deber&aacute;
              presentar:&nbsp;</span></p>
          <p><span style="font-weight: 400;">- Constancia de pase en tr&aacute;mite o anal&iacute;tico parcial&nbsp; de
              aprobaci&oacute;n de la actividad acad&eacute;mica, expedido por autoridad competente de la
              instituci&oacute;n.</span></p>
          <p>&nbsp;</p>
          <ol start="8">
            <li><span style="font-weight: 400;"> Diplomas</span></li>
          </ol>
          <p><span style="font-weight: 400;">&nbsp;8.1. El Instituto otorgar&aacute; el diploma de egresado al alumno
              regular que haya aprobado todas las actividades acad&eacute;micas.</span></p>
          <p><span style="font-weight: 400;">8.2. Asimismo extender&aacute; un certificado anal&iacute;tico de estudios
              en
              el que constar&aacute;n las actividades acad&eacute;micas aprobadas por el alumno, con indicaci&oacute;n
              de
              las notas obtenidas.&nbsp;</span></p>
          <p>&nbsp;</p>
          <ol start="9">
            <li><span style="font-weight: 400;"> R&eacute;gimen de convivencia&nbsp;</span></li>
          </ol>
          <p><span style="font-weight: 400;">9.1. El Instituto promover&aacute; el desarrollo de la tarea
              acad&eacute;mica
              en un marco de respeto mutuo entre los integrantes de su comunidad. En los casos en que los alumnos
              cometieran actos que afecten la convivencia y/o el prestigio del Instituto se prev&eacute;n sanciones que
              se
              aplicar&aacute;n guardando proporci&oacute;n con el tipo y la gravedad de la falta cometida.&nbsp;</span>
          </p>
          <p><span style="font-weight: 400;">9.2. Las sanciones previstas ser&aacute;n las siguientes:&nbsp;</span></p>
          <p><span style="font-weight: 400;">9.2.1. Apercibimiento.&nbsp;</span></p>
          <p><span style="font-weight: 400;">9.2.2. Amonestaci&oacute;n.&nbsp;</span></p>
          <p><span style="font-weight: 400;">9.2.3. Suspensi&oacute;n hasta un (1) a&ntilde;o.</span></p>
          <p><span style="font-weight: 400;">9.2.4. Expulsi&oacute;n.</span></p>
          <p><span style="font-weight: 400;">9.3. Ser&aacute;n causas de:&nbsp;</span></p>
          <p><span style="font-weight: 400;">9.3.1. Apercibimiento: Desobediencia ante &oacute;rdenes razonables y
              ajustadas a reglamento de autoridades, des&oacute;rdenes, faltas de respeto, inconductas, actitudes o
              expresiones contrarias al decoro, todos en grado leve.</span></p>
          <p><span style="font-weight: 400;">&nbsp;9.3.2. Amonestaci&oacute;n: Las mismas causas indicadas para el
              apercibimiento, en grado grave o en reincidencia.&nbsp;</span></p>
          <p><span style="font-weight: 400;">9.3.3. Suspensi&oacute;n: Injurias verbales a autoridades, da&ntilde;os a
              bienes de la Instituci&oacute;n, participaci&oacute;n en tumultos o desmanes dentro del Instituto,
              agresi&oacute;n f&iacute;sica a alumnos, reiteraci&oacute;n de hechos y actos que hubiesen dado lugar al
              apercibimiento o a la amonestaci&oacute;n.&nbsp;</span></p>
          <p><span style="font-weight: 400;">9.3.4. Expulsi&oacute;n: Promoci&oacute;n o realizaci&oacute;n de tumultos
              o
              desmanes, ocupaci&oacute;n de los locales institucionales, agresi&oacute;n f&iacute;sica a autoridades o
              profesores, adulteraci&oacute;n o falsificaci&oacute;n de documentos, reiteraci&oacute;n de actos que
              hubiesen originado la suspensi&oacute;n, ocultamiento de las situaciones indicadas en los apartados 9.7. y
              9.8. 9.4. La precedente enmarcaci&oacute;n no tendr&aacute; car&aacute;cter taxativo.&nbsp;</span></p>
          <p><span style="font-weight: 400;">9.5. La sanci&oacute;n de suspensi&oacute;n importar&aacute; siempre la
              prohibici&oacute;n de acceso a todas las dependencias del Instituto, inclusive en la suspensi&oacute;n
              preventiva que podr&aacute; disponer el Rector/a o Director/a. En este &uacute;ltimo caso, se
              permitir&aacute; el ingreso del alumno cuando sea requerida su presencia a efectos de la
              instrucci&oacute;n
              de la causa correspondiente. El incumplimiento de esta prohibici&oacute;n ser&aacute; sancionado con
              expulsi&oacute;n.&nbsp;</span></p>
          <p><span style="font-weight: 400;">9.6 Todo proceso disciplinario se realizar&aacute; por expediente
              p&uacute;blico y permanente que ser&aacute; publicado en la web institucional con los datos
              identificativos
              p&uacute;blicos contemplados la ley Ley 25.326 art&iacute;culo 5, inc. c. Con un sumario de los hechos y
              un
              informe pedag&oacute;gico. Sirviendo la aceptaci&oacute;n de este reglamento como consentimiento
              informado.&nbsp;</span></p>
          <p><span style="font-weight: 400;">9.7. El alumno becado sancionado perder&aacute; la beca y/o
              descuento.</span>
          </p>
          <p>&nbsp;</p>
          <ol start="10">
            <li><span style="font-weight: 400;"> Pagos&nbsp;</span></li>
          </ol>
          <p><span style="font-weight: 400;">10.1 Se llama &ldquo;Arancel&rdquo; al pago mensual que deber&aacute;
              realizar el alumno para mantener su condici&oacute;n regular.&nbsp;</span></p>
          <p><span style="font-weight: 400;">10.2 Se llama &ldquo;Matr&iacute;cula&rdquo; al pago&nbsp; que se realiza
              al
              momento de la inscripci&oacute;n de cada a&ntilde;o lectivo.</span></p>
          <p><span style="font-weight: 400;">10.3 Los aranceles se abonan de forma peri&oacute;dica del d&iacute;a 1 al
              10
              de cada mes. Estableci&eacute;ndose un valor con descuento del 10% (diez por ciento) por el pago en fecha
              en
              las cajas de la instituci&oacute;n. El pago fuera de la fecha correspondiente implica la p&eacute;rdida de
              dicho beneficio.&nbsp;</span></p>
          <p><span style="font-weight: 400;">10.4 El Instituto se reserva el derecho de modificar los importes, tanto de
              matr&iacute;cula como de cuotas.&nbsp;</span></p>
          <p><span style="font-weight: 400;">10.5 El alumno que debiera el pago de 1 (un) mes ser&aacute; dado de baja
              en
              el Sistema de Gesti&oacute;n Integral, ser&aacute; suspendida su cuenta de correo institucional y revocado
              su ingreso al edificio de la instituci&oacute;n.&nbsp;</span></p>
          <p><span style="font-weight: 400;">10.6 Para poder realizar la inscripci&oacute;n a ex&aacute;menes, materias
              o
              pedidos de documentaci&oacute;n el alumno no deber&aacute; presentar deuda.&nbsp; En el caso de baja de
              estudios, el alumno deber&aacute; tener el estado administrativo al d&iacute;a</span></p>
          <p><span style="font-weight: 400;">10.7 Algunos tr&aacute;mites a realizarse dentro de la instituci&oacute;n
              poseen costo.&nbsp;</span></p>
          <p><span style="font-weight: 400;">10.8 La regularidad del alumno permite al mismo cursar la cantidad
              correspondiente de materias al cuatrimestre en curso. Seg&uacute;n se encuentre establecido en los
              distintos
              planes de estudio.&nbsp;</span></p>
          <p><span style="font-weight: 400;">10.9 Plan Doble: Permite la inscripci&oacute;n al doble de las materias del
              cuatrimestre en curso, con un pago de un doble arancel; y doble matr&iacute;cula, si
              correspondiese.&nbsp;</span></p>
          <p><span style="font-weight: 400;">10.10 El alumno que al d&iacute;a del examen no tenga las cuotas al
              d&iacute;a no figurar&aacute; en el acta y por lo tanto no podr&aacute; rendir el mismo.&nbsp;</span></p>
          <p><span style="font-weight: 400;">10.11 Ning&uacute;n importe ser&aacute; reembolsado por motivo alguno, a
              excepci&oacute;n que el curso no comience.&nbsp;</span></p>
          <p><span style="font-weight: 400;">10.12. El Plan Finalidad es accesible a los alumnos que adeuden 5 materias
              o
              menos en sus anteriores colegios. Podr&aacute;n optar por esta modalidad abreviada de estudio, que
              contar&aacute; con el pago de 1 matr&iacute;cula y 5 cuotas mensuales del mismo valor.&nbsp;</span></p>
          <p><span style="font-weight: 400;">10.13 En caso de vencerse el plan de pago, el alumno&nbsp; deber&aacute;
              volver a realizar el mismo. No se aceptan pedidos de reintegro.&nbsp;</span></p>
          <p><span style="font-weight: 400;">10.14 En el caso que el alumno haya aplicado a alg&uacute;n programa de
              beca
              o descuento, siempre que el mismo requiera la suscripci&oacute;n a un sistema de d&eacute;bito
              autom&aacute;tico del arancel, deber&aacute; asegurarse de contar con los fondos suficientes. Si el alumno
              que habiendo aceptado el descuento y/o beca no realice la suscripci&oacute;n al d&eacute;bito o no
              disponga
              fondos suficientes durante los siguientes 30 d&iacute;as, perder&aacute; autom&aacute;ticamente el
              descuento
              y/o beca de forma permanente; y se proceder&aacute; a efectuar la baja de la
              instituci&oacute;n.&nbsp;</span></p>
          <p><span style="font-weight: 400;">10.15 Los aranceles se facturan todos los d&iacute;as 1ero de cada mes,
              siempre y cuando los alumnos sean alumnos activos de la instituci&oacute;n. El no pago del arancel es
              pasible, y ser&aacute; reclamado por v&iacute;as legales, reserv&aacute;ndose el derecho la
              instituci&oacute;n de informar el estado de morosidad a las entidades u organismos
              correspondientes.&nbsp;</span></p>
          <p>&nbsp;</p>
          <ol start="11">
            <li><span style="font-weight: 400;"> Equivalencias.&nbsp;</span></li>
          </ol>
          <p><span style="font-weight: 400;">11.1 Aquellos alumnos que presenten equivalencias podr&aacute;n cursar y
              rendir con car&aacute;cter condicional las materias correlativas de su plan de estudio.&nbsp;</span></p>
          <p><span style="font-weight: 400;">11.2 El alumno deber&aacute; presentar la documentaci&oacute;n
              respaldatoria
              a su pedido de equivalencias, seg&uacute;n corresponda: Pase, fotocopia sellada y firmada con copia fiel
              del
              libro matriz, o programas sellados y foliados con su correspondiente anal&iacute;tico. De forma
              provisional
              el alumno podr&aacute; firmar una declaraci&oacute;n jurada de materias.&nbsp;</span></p>
          <p><span style="font-weight: 400;">11.3 Si el alumno falsease la declaraci&oacute;n jurada de materias
              deber&aacute; proceder al cursado de las mismas extendiendos&eacute; en el acto el plazo para la
              finalizaci&oacute;n de sus estudios.&nbsp;</span></p>
          <p>&nbsp;</p>
          <ol start="12">
            <li><span style="font-weight: 400;"> Uso de la plataforma de gesti&oacute;n</span></li>
          </ol>
          <p><span style="font-weight: 400;">12.1 Los alumnos deben mantener el decoro en las publicaciones e
              interacciones dentro de la plataforma de gesti&oacute;n.</span></p>
          <p><span style="font-weight: 400;">12.2 No son aceptadas publicaciones con fines comerciales, de militancia
              pol&iacute;tica, ni propaganda sobre organizaciones no gubernamentales, as&iacute; como tampoco es
              aceptada
              ninguna publicaci&oacute;n de activismos, ya sean de &iacute;ndole pol&iacute;tico, de g&eacute;nero, de
              cuestiones ambientales, sociales u otros.&nbsp;</span></p>
          <p><span style="font-weight: 400;">12.3 Est&aacute; prohibido realizar actividades que impliquen interacciones
              no deseadas por otros alumnos tales como: bullying, grooming, acoso deliberado hacia otros alumnos,
              personal
              administrativo o docente de la instituci&oacute;n.&nbsp;</span></p>
          <p><span style="font-weight: 400;">12.4 Se encuentra prohibida la difusi&oacute;n de datos personales, estados
              de pago, consulta sobre pagos, datos de tarjetas de cr&eacute;dito en ning&uacute;n canal p&uacute;blico
              de
              la aplicaci&oacute;n institucional.&nbsp;</span></p>
          <p><span style="font-weight: 400;">12.5 Est&aacute; prohibida la publicaci&oacute;n de posteos que tengan como
              fin el deterioro de la confianza institucional y el menoscabo de la comunidad educativa.</span></p>
          <p><span style="font-weight: 400;">12.6 La instituci&oacute;n se reserva el derecho de moderar, incluyendo
              eliminar, las publicaciones que considere pertinentes.&nbsp;</span></p>
          <p><span style="font-weight: 400;">12.7 Los plazos de inscripci&oacute;n, tanto a cursado de materias, como a
              rendir ex&aacute;menes, no son prorrogables bajo ninguna circunstancia.&nbsp;</span></p>
          <p><span style="font-weight: 400;">12.8 El alumno se considera responsable de tener una conexi&oacute;n
              estable
              de internet a fines de presentarse a las instancias evaluativas correspondientes. No se admite
              ning&uacute;n
              tipo de excepci&oacute;n por problemas de conexi&oacute;n o de suministro el&eacute;ctrico.&nbsp;</span>
          </p>
          <p><span style="font-weight: 400;">12.9 Toda la actividad, incluyendo los datos generados dentro de la
              plataforma, se considera propiedad de la instituci&oacute;n. Reserv&aacute;ndose la instituci&oacute;n el
              derecho a la publicaci&oacute;n o uso de los mismos.&nbsp;</span></p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="acceptTerms">
            Acepto términos y condiciones
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showModalMedals" width="auto">
      <v-card>
        <v-card-title class="headline" primary-title>
          ¡Información!
        </v-card-title>
        <v-card-text class="mt-3 text-center d-flex flex-column justify-center align-center">
          Para obtener esta insignia debes estudiar dentro de la plataforma durante {{
            (tipoMedals == 1 ? '3' : (tipoMedals == 2 ? '5' : '10')) }} días seguidos.



        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" block @click="showModalMedals = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="tieneBadge" width="auto">
      <v-card>
        <v-card-title class="headline" primary-title>
          ¡Felicidades! ¡Continúa así...!
        </v-card-title>
        <v-card-text class="mt-3 text-center d-flex flex-column justify-center align-center">
          Has ganado el siguiente reconocimiento por haber ingresado {{
            (tipoMedals == 1 ? '3' : (tipoMedals == 2 ? '5' : '10')) }} días seguidos a la plataforma:

          <v-img class="mt-4" :aspect-ratio="16 / 9" width="150" contain
            :src="require('../assets/' + cadenaImgMedals + '.png')"></v-img>

        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" block @click="tieneBadge = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="tieneBadgeInicial" width="auto">
      <v-card>
        <v-card-title class="headline" primary-title>
          ¡Felicidades! ¡Continúa así...!
        </v-card-title>
        <v-card-text class="mt-3 text-center d-flex flex-column justify-center align-center">
          Has ganado el siguiente reconocimiento por haber ingresado a nuestra Plataforma

          <v-img class="mt-4" :aspect-ratio="16 / 9" width="150" contain
            :src="require('../assets/inicial.png')"></v-img>

        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" block @click="tieneBadgeInicial = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-dialog v-model="showModalRanking" width="auto">
      <v-card>
        <v-card-title class="headline text-center d-flex flex-column justify-center align-center pb-0" primary-title>
          Ranking {{ carreraPrincipal }}
        </v-card-title>
        <v-card-text class="mt-3 text-center d-flex flex-column justify-center align-center">
          <v-alert style="background-color: rgb(167, 186, 56);color: white;" title="Información">Este es un ranking que
            indica los días de estudio
            consecutivos</v-alert>
        </v-card-text>
        <v-card-text id="tabla_ranking" style="max-height: 300px;overflow: scroll">
          <v-simple-table>
            <thead>
              <tr>
                <th class="text-center">

                </th>
                <th class="text-center">
                  Posición
                </th>
                <th class="text-center">
                  Alumno
                </th>
                <th class="text-center">
                  Días Consecutivos
                </th>
              </tr>
            </thead>
            <tbody>
              <tr :id="'tr_ranking_' + lR.alumno_id" v-for="lR in listaRanking" :key="lR.alumno_id">
                <td
                  :style="lR.alumno_id == user.IDStB ? 'border: 3px solid rgb(167, 186, 56) ;border-style:solid none solid solid' : ''">
                  <v-avatar :size="user.imagen == null ? '40' : '60'" density="default" title="Ver Ranking">
                    <div class="v-image v-responsive theme--light">
                      <div class="v-responsive__sizer" style="padding-bottom: 190.399%;"></div>
                      <div class="v-image__image v-image__image--cover"
                        v-bind:style="{ 'background-image': 'url(' + (lR.imagen == null ? require('../assets/user.png') : require(user.imagen)) + ')', 'background-position': 'center center' }">
                      </div>
                      <div class="v-responsive__content" style="width: 1229px;"></div>
                    </div>
                  </v-avatar>
                </td>
                <td
                  :style="lR.alumno_id == user.IDStB ? 'border: 3px solid rgb(167, 186, 56) ;border-style:solid none solid none' : ''"
                  class="text-center">
                  {{ lR.posicion }}
                </td>
                <td
                  :style="lR.alumno_id == user.IDStB ? 'border: 3px solid rgb(167, 186, 56) ;border-style:solid none solid none' : ''"
                  class="text-center">
                  {{ lR.nombre }}
                </td>
                <td
                  :style="lR.alumno_id == user.IDStB ? 'border: 3px solid rgb(167, 186, 56) ;border-style:solid solid solid none' : ''"
                  class="text-center">
                  {{ lR.cantidad }}
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" block @click="showModalRanking = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import StarRating from 'vue-star-rating'
import SocketConnection from "itoeste-socket"
import { DEBUG, API_SOCKET } from "../../env";

// ponytail: cache en memoria por pestaña. CardIeaAppMain envuelve cada vista y su mounted()
// pedía getAlumno, obtenerPosicion y notifications-total en CADA cambio de ruta: en el pico
// del 04/11 eran ~30 req/min por alumno y saturaban PHP-FPM. Se pierde al recargar la página.
const cacheApi = {};
function getCacheado(api, url, ttlMs, userId) {
  const key = userId + '|' + url;
  const c = cacheApi[key];
  if (c && Date.now() - c.t < ttlMs) return c.p;
  const p = api.get({ url: url, data: {} }).then((res) => {
    if (!res) delete cacheApi[key]; // error resuelto como vacío: no cachearlo
    return res;
  }, (err) => {
    delete cacheApi[key];
    throw err;
  });
  cacheApi[key] = { t: Date.now(), p: p };
  return p;
}
function invalidarCache(url) {
  Object.keys(cacheApi).forEach((k) => { if (k.endsWith('|' + url)) delete cacheApi[k]; });
}
export default {
  props: {
    ocultarHeaderMobile: {
      type: Boolean,
      default: false,
    },
    profile: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      rating: 1.0,
      showRating: false,
      notifications: {
        'general': { total: 0, items: [] },
        'message': { total: 0, items: [] },
        'post': { total: 0, items: [] },
      },
      notificationsDocente: {
        'general': { total: 0, items: [] },
        'message': { total: 0, items: [] },
        'post': { total: 0, items: [] },
      },
      showTerms: false,
      showPase: false,
      archivo_descargado: false,
      url_archivo: '',
      ws: null,
      showModalMedals: false,
      tipoMedals: 1,
      cadenaImgMedals: 'oro2',
      tieneBadge: false,
      tieneBadgeInicial: false,
      posicionRanking: 0,
      showModalRanking: false,
      listaRanking: [],
      mostrarPosicion: false,
      mostrarAlerta: false
    };
  },
  components: {
    StarRating,
  },
  mounted() {
    let hoy = new Date()
    let limite = new Date('2025-09-01')

    if (hoy < limite) {
      this.mostrarAlerta = true
    }
    console.log("este elemento", this.user)

    if (this.user && this.user.IDStB) {
      if (this.$route.name == 'ReviewPass' || this.$route.name == 'CargaArchivo' || this.$route.name == 'CircuitoPreInscripcionv2' || this.$route.name == 'CargaArchivoparams' || this.$route.name == "Circuito") {
        this.$API
          .get({
            url: "alumno/logout?web=true",
            data: {}
          })
          .then(() => {
            this.$store.dispatch("token", "");
            this.$store.dispatch("user", {});
            this.$store.dispatch("tieneBadge1", false)
            this.$store.dispatch("tieneBadge2", false)
            this.$store.dispatch("tieneBadge3", false)
            this.$store.dispatch("porcentaje1", 0)
            this.$store.dispatch("porcentaje2", 0)
            this.$store.dispatch("porcentaje3", 0)
            this.$store.dispatch("primeroIngreso", false)
            this.$store.dispatch("apareceModalInicial", false)
            this.$store.dispatch("carreraPrincipal", "")
            this.$store.dispatch("imagenbs", "")
          });

        return
      }
      console.log('ingresa')
      //Se obtienen los datos del alumno
      let that = this;
      if (this.user.tipoUsuario == "alumno") {
        console.log('This user:', this.user);
        getCacheado(this.$API, "alumno/getAlumno", 60 * 1000, this.user.IDStB)
          .then((res) => {
            if (res) {
              this.rating = res.puntaje
              this.showRating = true;
              this.mostrarPosicion = true;
              this.showTerms = res.terms == 1 ? false : true;
              this.showPase = res.acepta_pase
              this.url_archivo = res.url_pase
              that.$store.dispatch("user", {
                ...this.user,
                borrado: res.Borrado,
                alumno_mora: res.alumno_mora,
                validacion_inscripcion: res.validacion_inscripcion,
                pendiente_documentos_inscripcion: res.pendiente_documentos_inscripcion
              });
            }
          });

        getCacheado(this.$API, "alumno/obtenerPosicion", 5 * 60 * 1000, this.user.IDStB).then((res) => {
          this.posicionRanking = res.posicion;
        });

        //Se obtienen las notificaciones
        getCacheado(this.$API, "notifications-total", 60 * 1000, this.user.IDStB)
          .then((res) => {
            if (res) {
              let m = res.filter(d => { return (d.type == 'message') });
              if (m.length > 0) {
                //this.notifications.message.total = m[0].total;  
                this.notifications.general.total = m[0].total;
              }
              let p = res.filter(d => { return (d.type == 'post') });
              if (p.length > 0) {
                //this.notifications.post.total = p[0].total;  
                this.notifications.general.total = p[0].total;

              }

              let g = res.filter(d => { return (d.type == 'general') });
              if (g.length > 0) {
                this.notifications.general.total = g[0].total;
              }
            }
          });

      }

      if (this.user.tipoUsuario === "operador") {
        console.log('Esto es es el id del operador ', this.user.IDStB);
        this.$API
          .get({
            url: `operador/getOperador/${this.user.IDStB}`,
            data: {},
          })
          .then((res) => {
            this.rating = res.puntaje;
            this.showRating = true;
          })
          .catch((error) => {
            console.error('Error al obtener el operador:', error);
          });
      }


      if (this.user.tipoUsuario === 'profesor') {
        this.$API
          .get({
            url: "notifications-total-docente",
            data: {},
          })
          .then((res) => {
            if (res) {
              let m = res.filter(d => { return (d.type == 'message') });
              if (m.length > 0) {
                //this.notifications.message.total = m[0].total;  
                this.notificationsDocente.general.total = m[0].total;
              }
              let p = res.filter(d => { return (d.type == 'post') });
              if (p.length > 0) {
                //this.notifications.post.total = p[0].total;  
                this.notificationsDocente.general.total = p[0].total;

              }

              let g = res.filter(d => { return (d.type == 'general') });
              if (g.length > 0) {
                this.notificationsDocente.general.total = g[0].total;
              }
              console.log(this.notificationsDocente)
            }
          });
      }

      this.ws = SocketConnection({
        debug: DEBUG,
        token: API_SOCKET,
        user: this.$store.getters.user.IDStB
      }, () => {

      });
      this.ws.subscribeChannel('notification-' + this.user.IDStB, (result) => {
        console.log('llego por curl notificc')
        console.log(result);
        this.notifications.general.total++; invalidarCache("notifications-total");
        /*
        switch (result.type){
            case "post":
              this.notifications.post.total++;
            break;
            case "message":
              this.notifications.message.total++;
            break;
            case "general":
              this.notifications.general.total++; invalidarCache("notifications-total");
            break;
          }
          */
      });
      this.ws.subscribeChannel('chat-' + this.user.IDStB, (result) => {
        console.log('llego por curl notifi')
        console.log(result);
        switch (result.action) {
          case "chat-new", "message-new":
            this.addNotificationMessage(result)
            break;
        }
      });
    }
  },
  computed: {
    tieneBadge1() {
      return this.$store.getters.tieneBadge1;
    },
    tieneBadge2() {
      return this.$store.getters.tieneBadge2;
    },
    tieneBadge3() {
      return this.$store.getters.tieneBadge3;
    },
    token() {
      return this.$store.getters.token;
    },
    user() {
      return this.$store.getters.user;
    },
    porcentaje1() {
      return this.$store.getters.porcentaje1;
    },
    porcentaje2() {
      return this.$store.getters.porcentaje2;
    },
    porcentaje3() {
      return this.$store.getters.porcentaje3;
    },
    apareceModalInicial() {
      return this.$store.getters.apareceModalInicial;
    },
    primeroIngreso() {
      return this.$store.getters.primeroIngreso;
    },
    carreraPrincipal() {
      return this.$store.getters.carreraPrincipal;
    },
    imagenbs() {
      return this.$store.getters.imagenbs;
    }
  },
  methods: {

    obtenerAlumno() {
      invalidarCache("alumno/getAlumno");
      this.$API
        .get({
          url: "alumno/getAlumno",
          data: {},
        })
        .then((res) => {
          if (res) {

            this.$store.dispatch("user", {
              ...this.user,
              borrado: res.Borrado,
              alumno_mora: res.alumno_mora,
              validacion_inscripcion: res.validacion_inscripcion,
              pendiente_documentos_inscripcion: res.pendiente_documentos_inscripcion
            });
          }
        });
    },
    mostrarModalInicial() {
      this.tieneBadgeInicial = true;
    },
    obtenerPosicion() {
      this.$API.get({
        url: "alumno/obtenerPosicion",
        data: {}
      }).then((res) => {
        this.posicionRanking = res.posicion;
      });
    },
    modalRanking() {
      this.showModalRanking = true;
      this.obtenerPosicion()

      this.$API.get({
        url: "alumno/obtenerRanking",
        data: {}
      }).then((res) => {
        this.listaRanking = res
        console.log('ejecuta ranking')
        this.$nextTick(() => {
          let tabla_ranking = document.getElementById("tabla_ranking")
          let tr_ranking_ = document.getElementById("tr_ranking_" + this.user.IDStB)

          tabla_ranking.scrollTop = tr_ranking_.offsetTop - tabla_ranking.offsetTop + 20
        });

      })
    },
    modalBadge(tipoBadge) {
      this.tipoMedals = tipoBadge
      if (tipoBadge == 1) {
        this.cadenaImgMedals = 'bronce2'
      } else if (tipoBadge == 2) {
        this.cadenaImgMedals = 'plata2'
      } else {
        this.cadenaImgMedals = 'oro2'
      }

      this.showModalMedals = true

    },
    modalBadgeGanado(tipoBadge) {
      this.tipoMedals = tipoBadge
      if (tipoBadge == 1) {
        this.cadenaImgMedals = 'bronce2'
      } else if (tipoBadge == 2) {
        this.cadenaImgMedals = 'plata2'
      } else {
        this.cadenaImgMedals = 'oro2'
      }

      this.tieneBadge = true

    },
    async logout() {
      let that = this;
      await this.$API
        .get({
          url: "alumno/logout?web=true",
          data: {}
        })
        .then(() => {
          setTimeout(() => {
            that.$store.dispatch("token", "");
            that.$store.dispatch("user", {});
            that.$store.dispatch("tieneBadge1", false)
            that.$store.dispatch("tieneBadge2", false)
            that.$store.dispatch("tieneBadge3", false)
            that.$store.dispatch("porcentaje1", 0)
            that.$store.dispatch("porcentaje2", 0)
            that.$store.dispatch("porcentaje3", 0)
            that.$store.dispatch("primeroIngreso", false)
            that.$store.dispatch("apareceModalInicial", false)
            that.$store.dispatch("carreraPrincipal", "")
            that.$store.dispatch("imagenbs", "")

            that.$router.replace({ name: "Login" });
          }, 1000);
        });
    },
    async changePassword() {
      this.$router.push({
        name: 'ChangePassword'
      });
    },
    async LoadNotifications(tipo) {
      console.log(tipo)
      //this.notifications[tipo].total = 0
      this.$API
        .get({
          //url: "notifications?per_page=5&type=" + tipo 
          url: "notifications?per_page=5"
        }).then((res) => {
          this.notifications['general'].items = res.data;
          if (this.notifications['general'].total > 0) {
            invalidarCache("notifications-total");
            this.$API
              .post({
                url: "notifications-reset",
                data: {}
              }, false)
          }
        });
    },
    async LoadNotificationsDocente(tipo) {
      console.log(tipo)
      //this.notifications[tipo].total = 0
      this.$API
        .get({
          //url: "notifications?per_page=5&type=" + tipo 
          url: "notifications?per_page=5"
        }).then((res) => {
          this.notificationsDocente['general'].items = res.data;
          if (this.notificationsDocente['general'].total > 0) {
            this.$API
              .post({
                url: "notifications-reset",
                data: {}
              }, false)
          }
        });
    },
    openPublication(id) {
      this.$router.replace({
        name: 'Publicaciones',
        params: { id: id }
      });
    },
    addNotificationMessage(result) {
      console.log(result)
      let ch = JSON.parse(result.message);
      if (ch.alumno_id !== this.user.IDStB) {
        //this.notifications.message.total++;  
        this.notifications.general.total++; invalidarCache("notifications-total");
      }
    },
    goPublications() {
      this.$router.push({
        name: 'Publicacion'
      });
    },
    goChats() {
      this.$router.push({
        name: 'Chat'
      });
    },
    goChat(id) {
      this.$router.push({
        name: 'Chat',
        params: { id: id },
        query: {
          t: new Date().getTime(),
        }
      });
    },
    goPublication(id) {
      this.$router.push({
        name: 'Publicacion',
        params: { id: id },
        query: {
          t: new Date().getTime(),
        }
      });
    },
    openNotification(notification) {
      if (notification.type == 'message') {
        this.goChat(notification.origin_id);
      } else if (notification.type == 'post') {
        this.goPublication(notification.origin_id);
      }

    },
    async acceptTerms() {
      await this.$API
        .post({
          url: "alumno/acceptTerms",
          data: {},
        })
        .then((res) => {
          if (res) {
            this.showTerms = false;
            this.obtenerAlumno()
          } else {
            alert('Ocurrió un error, intente mas tarde')
          }
        });

    },
    async acceptPase() {
      await this.$API
        .post({
          url: "alumno/acceptPase",
          data: {},
        })
        .then((res) => {
          if (res) {
            this.showPase = false;
            this.obtenerAlumno()
          } else {
            alert('Ocurrió un error, intente mas tarde')
          }
        });
    },
    descargarpase() {
      this.archivo_descargado = true
    }
  }
};
</script>
<style>
.badge-no {
  -webkit-filter: grayscale(100%);
  /* Safari 6.0 - 9.0 */
  filter: grayscale(100%);
  /* opacity: 0.5; */
}
</style>